var nsModuleExport = function(root,name,prototype)
	{
		if(typeof exports === 'object' && typeof module === 'object')
		{
			module.exports[name] = prototype;
		}
		else if (typeof define === "function" && define.amd)
		{
			define(name,[], function () {return prototype;});
		}
		else if(typeof exports === 'object')
		{
			exports[name] = prototype;
		}
		else
		{
			root[name] = prototype;
		}
	};var nsIsWeb = function(root)
	{
		if(typeof exports === 'object' && typeof module === 'object')
		{
			return false;
		}
		else if (typeof define === "function" && define.amd)
		{
			return false;
		}
		else if(typeof exports === 'object')
		{
			return false;
		}
		else
		{
			return true;
		}
	};if(!nsIsWeb())
		{
var nsutilRef = require('./nsUtil.min.js');
var NSUtil = nsutilRef.NSUtil;
var nscontainerbaseRef = require('./nsContainerBase.min.js');
var nsExtendPrototype = nscontainerbaseRef.nsExtendPrototype;
var NSContainerBase = nscontainerbaseRef.NSContainerBase;
var svgRef = require('./nsSVG.min.js');
var NSSvg = svgRef.NSSvg;
var NSSvgShapes = svgRef.NSSvgShapes;
var plugginsRef = require('./nsPluggins.min.js');
var nsTextEditor = plugginsRef.nsTextEditor;
var nsTextAreaEditor = plugginsRef.nsTextAreaEditor;
var NSCellSelection = plugginsRef.NSCellSelection;
var NSTableCellNavigator = plugginsRef.NSTableCellNavigator;
var dateutilRef = require('./nsDateUtil.min.js');
var NSDateUtil = dateutilRef.NSDateUtil;

		}
var NSDragDrop = (function()
{
	var NSDragDrop = function(setting)
	{
		this.ITEM_DROPPING = "itemDropping";
		this.ITEM_DROPPED = "itemDropped";
		this.DRAG_STARTING = "dragStarting";
		this.DRAG_STARTED = "dragStarted";
		this.DRAGGING = "dragging";
		this.DRAG_END = "dragEnd";
		
		this.__setting = setting;
		this.util = new NSUtil();
		this.__id = null;
		this.__config = null;
		this.__data = null;
		
		this.__parentContainerType = null;
		this.__divMovable = null;
		this.__compPlaceholder = null;
		this.__itemPosition = null;
		this.__objSelectedItem = {scrollableContainer:null,containment:null};
		this.__lastTarget = null;
		this.__isDragging = false;
		this.__holdTimeoutInterval = -1;
		this.__documentMouseMoveRef = null;
		this.__documentMouseUpRef = null;
		this.__documentMouseMoveHoldRef = null;
		this.__documentMouseUpHoldRef = null;
		
		this.__initialize();
	};
	
	NSDragDrop.prototype.remove = function() 
	{ 
		
	};
	
	NSDragDrop.prototype.setDragData = function(data) 
	{ 
		this.__data = data;
	};
	
	NSDragDrop.prototype.getDragData = function() 
	{ 
		return this.__data;
	};
	
	NSDragDrop.prototype.__initialize = function()
	{
		if(this.__setting)
		{
			this.__config = {
					container: this.__setting["container"] || null,
					childNodeType: this.__setting["childNodeType"] || null,
					isContainerDraggable:(this.util.isUndefinedOrNull(this.__setting["isContainerDraggable"]) ? true : Boolean.parse(this.__setting["isContainerDraggable"])),
					isContainerDroppable:(this.util.isUndefinedOrNull(this.__setting["isContainerDroppable"]) ? true : Boolean.parse(this.__setting["isContainerDroppable"])),
					enableDragByHandle: Boolean.parse(this.__setting["enableDragByHandle"]),
					dragHandlerClass: this.__setting["dragHandlerClass"] || "nsDragHandler",
					enableDragAfterHold: Boolean.parse(this.__setting["enableDragAfterHold"]),
					enableCloneMode: Boolean.parse(this.__setting["enableCloneMode"]),
					holdTime:(this.util.isUndefinedOrNull(this.__setting["holdTime"]) ? 500 : parseInt(this.__setting["holdTime"])),
					createCloneCallback: (this.__setting["createCloneCallback"] ? this.util.getFunction(this.__setting["createCloneCallback"]) : null),
					createPlaceholderCallback: (this.__setting["createPlaceholderCallback"] ? this.util.getFunction(this.__setting["createPlaceholderCallback"]) : null),
					nodeDroppableCallback: (this.__setting["nodeDroppableCallback"] ? this.util.getFunction(this.__setting["nodeDroppableCallback"]) : null),
					nodeDraggableCallback: (this.__setting["containerDroppableCallback"] ? this.util.getFunction(this.__setting["containerDroppableCallback"]) : null),
					insertNodeCallback: (this.__setting["insertNodeCallback"] ? this.util.getFunction(this.__setting["insertNodeCallback"]) : null),
					moveNodeCallback: (this.__setting["moveNodeCallback"] ? this.util.getFunction(this.__setting["moveNodeCallback"]) : null),
					removeNodeCallback: (this.__setting["removeNodeCallback"] ? this.util.getFunction(this.__setting["removeNodeCallback"]) : null),
					nodeDragHoverClass: this.__setting["nodeDragHoverClass"] || "nsNodeDragHover",
					nodeDraggingClass: this.__setting["nodeDraggingClass"] || "nsNodeDraggingClass"
			};
			if(this.__config.container && this.__config.childNodeType)
			{
				this.__parentContainerType = this.__config.container.tagName;
				this.__prepareContainer();
				this.__initializeChildren();
			}
		}
	};
	
	NSDragDrop.prototype.__initializeChildren = function()
	{
		var arrChildNode = this.__config.container.getElementsByTagName(this.__config.childNodeType);
		var childNode = null;
		for (var count = 0; count < arrChildNode.length; count++) 
		{
			childNode = arrChildNode[count];
			this.__prepareChildNode(childNode,count);
		}
	};
	
	NSDragDrop.prototype.__prepareContainer = function()
	{
		var container = this.__config.container;
		var nsObject = {};
		nsObject.id = this.__getID(); 
		nsObject.isDraggable = this.__config.isContainerDraggable;
		nsObject.isDroppable = this.__config.isContainerDroppable;
		nsObject.insertNode = this.__insertNode.bind(this);
		nsObject.moveNode = this.__moveNode.bind(this);
		nsObject.removeNode = this.__removeNode.bind(this);
		container.nsObject = nsObject;
		var draggableClass = nsObject.isDraggable ? "nsDraggableContainer" : "nsNonDraggableContainer";
		var droppableClass = nsObject.isDroppable ? "nsDroppableContainer" : "nsNonDroppableContainer";
		this.util.addStyleClass(container,draggableClass);	
		this.util.addStyleClass(container,droppableClass);
		var containerWebNode = this.util.getWebComponentElement(container);
		containerWebNode.nsObject = nsObject;
	};
	
	NSDragDrop.prototype.__prepareChildNode = function(childNode,index)
	{
		var isDragEnabled = this.__isNodeDraggable(childNode);
		var isDropEnabled = this.__isNodeDroppable(childNode);
		var nsObject = {};
		nsObject.parent = this.__config.container;
		nsObject.index = index;
		this.util.removeStyleClass(childNode,this.__config.nodeDragHoverClass);
		if(isDragEnabled) 
		{
			nsObject.position = this.util.getOffSet(childNode);
			this.util.addStyleClass(childNode,"nsNodeDragEnabled");	
			if(this.__config.enableDragByHandle)
			{
				var handle = childNode.querySelector("." + this.__config.dragHandlerClass);
				if(handle)
				{
					this.util.addEvent(handle,"mousedown",this.__childMouseDownHandler.bind(this));
					this.util.addEvent(handle,"touchstart",this.__childMouseDownHandler.bind(this));
					this.util.addEvent(childNode,"mousedown",this.__dragStartPreventHandler.bind(this));
					this.util.addEvent(childNode,"touchstart",this.__dragStartPreventHandler.bind(this));
				}
			}
			else if(this.__config.enableDragAfterHold)
			{
				this.util.addEvent(childNode,"mousedown",this.__childHoldMouseDownHandler.bind(this));
				this.util.addEvent(childNode,"touchstart",this.__childHoldMouseDownHandler.bind(this));
			}
			else
			{
				this.util.addEvent(childNode,"mousedown",this.__childMouseDownHandler.bind(this));
				this.util.addEvent(childNode,"touchstart",this.__childMouseDownHandler.bind(this));
			}
		}
		else
		{
			this.util.addStyleClass(childNode,"nsNodeDragDisable");					
		}
		nsObject.dragEnabled = isDragEnabled;
		nsObject.dropEnabled = isDropEnabled;
		childNode.nsObject = nsObject;
		var childWebNode = this.util.getWebComponentElement(childNode);
		childWebNode.nsObject = nsObject;
	};
	
	NSDragDrop.prototype.__childHoldMouseDownHandler= function(event)
	{
		this.__clearHoldTime();
		var self = this;
		this.__holdTimeoutInterval = setTimeout(function () {
	         self.__childMouseDownHandler.bind(self)(event);
	       },this.__config.holdTime);
		this.__addDocumentHoldListener();
	};
	
	NSDragDrop.prototype.__documentMouseMoveHoldHandler = function(event)
	{
		this.__clearHoldTime();
	};
	
	NSDragDrop.prototype.__documentMouseUpHoldHandler = function(event)
	{
		this.__clearHoldTime();
	};
	
	NSDragDrop.prototype.__childMouseDownHandler= function(event)
	{
		if(!this.__isDragging)
		{
			this.__clearHoldTime();
			event = this.util.getEvent(event);
		    var target = this.util.getTarget(event);
		    target = this.util.findParent(target,this.__config.childNodeType);
		    if(target && target["nsObject"] && target["nsObject"]["dragEnabled"] && target["nsObject"]["parent"] 
		    	&& target["nsObject"]["parent"]["nsObject"] && target["nsObject"]["parent"]["nsObject"]["isDraggable"])
			{
		    	var cancelled = this.util.dispatchEvent(this.__config.container,this.DRAG_STARTING,{node:target},{node:target},true,true);
		 		if(!cancelled)
		 		{
			    	this.__isDragging = true;
			    	this.__addDocumentListener();
			    	//TODO: Find parent with scroll
			    	this.__objSelectedItem.scrollableContainer = document.documentElement;
			    	//TODO: Find parent for containment
			    	this.__objSelectedItem.containment = document.body;
			    	this.__itemPosition = this.__positionStarted(event,target,this.__objSelectedItem.scrollableContainer);
				    this.util.makeBodyUnselectable();
				    // remove text selection (Chrome, FF, Opera, Safari)
				    if (window.getSelection) 
				    {
						window.getSelection().removeAllRanges();
					}
					// IE8
					else if (document.selection && document.selection.type === "Text") 
					{
						try 
						{
							document.selection.empty();
						}
						catch (error) 
						{
						}
					}
				    if(!this.__config.enableCloneMode)
					{
						this.__compPlaceholder = this.__createPlaceholder(target);
						this.__compPlaceholder = this.util.getWebComponentElement(this.__compPlaceholder);
						this.util.insertAfterElement(target,this.__compPlaceholder);
					}
					this.__divMovable = this.__cloneNode(target);
					this.util.addStyleClass(target,this.__config.nodeDraggingClass);
					this.__movePosition(event,this.__divMovable,this.__itemPosition,this.__objSelectedItem.containment,"absolute",this.__objSelectedItem.scrollableContainer);
					//adding offset to movable component if enableDragAfterHold is true so that users see that a clone has been created
					if(this.__config.enableDragAfterHold)
					{
						var rectMovable = this.__divMovable.getBoundingClientRect();
						this.__divMovable.style.left = (rectMovable.left + 5) + "px";
						this.__divMovable.style.top = (rectMovable.top + 5) + "px";
					}
					this.util.dispatchEvent(this.__config.container,this.DRAG_STARTED,target,{item:target});
					//assuming data has been set as this is last step before dragging starts
					target["nsObject"]["data"] = this.util.cloneObject(this.__data);
					event.stopPropagation();
		 		}
			}
			return false;
		}
	};
	
	NSDragDrop.prototype.__documentMouseMoveHandler = function(event)
	{
		if(this.__divMovable)
		{
			var orignalNode = null;
			if(this.__divMovable["nsObject"] && this.__divMovable["nsObject"]["orignalNode"])
			{
				orignalNode = this.__divMovable["nsObject"]["orignalNode"];
			}
			event = this.util.getEvent(event);
			var objTargetElement = this.__getTargetElementDetails(event,orignalNode);
			var targetX = objTargetElement.x;
		    var targetY = objTargetElement.y;
		    var targetElement = objTargetElement.element;
		    if(this.__lastTarget)
		    {
		    	this.util.removeStyleClass(this.__lastTarget,this.__config.nodeDragHoverClass);
		    }
		    this.__movePosition(event,this.__divMovable,this.__itemPosition, this.__objSelectedItem.containment,"absolute",this.__objSelectedItem.scrollableContainer);
		    if(targetElement && targetElement["nsObject"] && targetElement["nsObject"]["parent"] 
	    		&& targetElement["nsObject"]["parent"]["nsObject"] && targetElement["nsObject"]["parent"]["nsObject"]["isDroppable"])
		    {
		    	var container = objTargetElement.parent;
			    var objTargetNSObject = targetElement["nsObject"];
			    if(this.__config.enableCloneMode)
			    {
			    	this.util.addStyleClass(targetElement,this.__config.nodeDragHoverClass);
			    }
			    else
			    {
			    	if (this.__lastTarget !== targetElement) 
			    	{
			    		var placeholderIndex = this.__getPlaceHolderIndex(container);
				        if (placeholderIndex < 0) 
				        {
				        	this.__insertBefore(targetElement);
				        } 
				        else 
				        {
				        	if (placeholderIndex <= objTargetNSObject.index) 
					        {
				        		this.__insertAfter(targetElement);
					        } 
					        else 
					        {
					        	this.__insertBefore(targetElement);
					        }
				        }
			        }
			    }
		    }
	 	    var data = {node:orignalNode,x:targetX,y:targetY,targetNode:targetElement};
	 	    this.util.dispatchEvent(this.__config.container,this.DRAGGING,data,{item:data});
		    this.util.preventDefault(event);
		    this.__lastTarget = targetElement;
		    return false;
		}
	};
	
	NSDragDrop.prototype.__documentMouseUpHandler = function(event)
	{
		this.__removeDocumentListener();
		if(this.__divMovable)
		{
			var orignalNode = null;
			var nodeData = null;
			if(this.__divMovable["nsObject"] && this.__divMovable["nsObject"]["orignalNode"])
			{
				orignalNode = this.__divMovable["nsObject"]["orignalNode"];
				if(orignalNode && orignalNode["nsObject"])
				{
					nodeData = orignalNode["nsObject"]["data"];
				}
			}
			event = this.util.getEvent(event);
			var objTargetElement = null;
			var isPlaceholder = false;
			if(this.__config.enableCloneMode)
			{
				objTargetElement = this.__getTargetElementDetails(event,orignalNode);
			}
			else
			{
				objTargetElement = this.__getPlaceholderDetails(event);
				isPlaceholder = true;
			}
			var targetX = objTargetElement.x;
		    var targetY = objTargetElement.y;
		    var hasElementChanged = false;
		    var targetElement = objTargetElement.element;
		    if(targetElement && (isPlaceholder || targetElement["nsObject"] && targetElement["nsObject"]["parent"] 
				&& targetElement["nsObject"]["parent"]["nsObject"] && targetElement["nsObject"]["parent"]["nsObject"]["isDroppable"]))
		    {
		    	var container = objTargetElement.parent;
		    	if(container && container.tagName.toLowerCase() === "tbody")
		    	{
		    		container = this.util.findParent(container,"table");
		    	}
		    	var objTargetNSObject = null;
		    	var targetIndex = -1;
		    	if(this.__config.enableCloneMode)
				{
		    		objTargetNSObject = targetElement["nsObject"];
		    		targetIndex = objTargetNSObject["index"];
				}
		    	else
		    	{
		    		targetIndex = Array.prototype.indexOf.call(targetElement.parentNode.children,targetElement);
		    	}
		    	var item = (nodeData ? nodeData : {});
		    	item.targetNode = targetElement;
		    	item.node = orignalNode;
		    	if(container)
		    	{
		    		var cancelled = this.util.dispatchEvent(container,this.ITEM_DROPPING,item,{item:item},true,true);
			 		if(!cancelled)
			 		{
			 			if(orignalNode === targetElement)
			 			{
			 				hasElementChanged = false;
			 				this.__animateInvalidDrop(orignalNode);
			 				console.debug("Item has not changed");
			 			}
			 		    if(this.__isSameContainer(container))
			 		    {
			 		    	if(orignalNode["nsObject"]["index"] !== targetIndex)
			 		    	{
			 		    		this.__moveNode(orignalNode,targetIndex,targetElement,nodeData);
			 		    		hasElementChanged = true;
			 		    	}
			 		    }
			 		    else
			 		    {
			 		    	this.__removeNode(orignalNode,nodeData);
			 		    	if(container["nsObject"] && container["nsObject"]["insertNode"])
			 		    	{
			 		    		container["nsObject"]["insertNode"](orignalNode,targetIndex,targetElement,nodeData);
			 		    	}
			 		    	hasElementChanged = true;
			 		    }
			 		    this.util.dispatchEvent(container,this.ITEM_DROPPED,item,{item:item},true,false);
			 		}
			 		else
					{
			 			hasElementChanged = false;
			 			this.__animateInvalidDrop(orignalNode);
						console.debug("Item drop was cancelled");
					}
		    	}
		    	else
				{
			    	hasElementChanged = false;
					this.__animateInvalidDrop(orignalNode);
					console.debug("Item was dropped at invalid location");
				}
		    }
		    else
			{
		    	hasElementChanged = false;
				this.__animateInvalidDrop(orignalNode);
				console.debug("Item was dropped at invalid location");
			}
		    if(hasElementChanged)
		    {
		    	this.__dragEndCleanUp();
		    }
		    this.util.dispatchEvent(this.__config.container,this.DRAG_END,orignalNode,{item:orignalNode},true,false);
			this.util.preventDefault(event);
		    event.stopPropagation();
			return false;
		}
		this.__dragEndCleanUp();
	};
	
	NSDragDrop.prototype.__dragStartPreventHandler = function(event)
	{
		event = this.util.getEvent(event);
		this.util.preventDefault(event);
	    event.stopPropagation();
	};
	
	NSDragDrop.prototype.__addDocumentListener = function() 
	{
		if(!this.__documentMouseMoveRef)
		{
			this.__documentMouseMoveRef = this.__documentMouseMoveHandler.bind(this);
			this.util.addEvent(document,"mousemove",this.__documentMouseMoveRef);
		}
		if(!this.__documentMouseUpRef)
		{
			this.__documentMouseUpRef = this.__documentMouseUpHandler.bind(this);
			this.util.addEvent(document,"mouseup",this.__documentMouseUpRef);
		}
	};
	
	NSDragDrop.prototype.__removeDocumentListener = function() 
	{
		if(this.__documentMouseMoveRef)
		{
			this.util.removeEvent(document,"mousemove",this.__documentMouseMoveRef);
			this.__documentMouseMoveRef = null;
		}
		if(!this.__documentMouseUpRef)
		{
			this.util.removeEvent(document,"mouseup",this.__documentMouseUpRef);
			this.__documentMouseUpRef = null;
		}
	};
	
	NSDragDrop.prototype.__addDocumentHoldListener = function() 
	{
		if(!this.__documentMouseMoveHoldRef)
		{
			this.__documentMouseMoveHoldRef = this.__documentMouseMoveHoldHandler.bind(this);
			this.util.addEvent(document,"mousemove",this.__documentMouseMoveHoldRef);
		}
		if(!this.__documentMouseUpHoldRef)
		{
			this.__documentMouseUpHoldRef = this.__documentMouseUpHoldHandler.bind(this);
			this.util.addEvent(document,"mouseup",this.__documentMouseUpHoldRef);
		}
	};
	
	NSDragDrop.prototype.__removeDocumentHoldListener = function() 
	{
		if(this.__documentMouseMoveHoldRef)
		{
			this.util.removeEvent(document,"mousemove",this.__documentMouseMoveHoldRef);
			this.__documentMouseMoveHoldRef = null;
		}
		if(!this.__documentMouseUpHoldRef)
		{
			this.util.removeEvent(document,"mouseup",this.__documentMouseUpHoldRef);
			this.__documentMouseUpHoldRef = null;
		}
	};
	
	NSDragDrop.prototype.__animateInvalidDrop = function(orignalNode)
	{
		if(this.__divMovable && orignalNode)
		{
			var self = this;
			var transitionEndCallback = function()
			{
				self.util.removeStyleClass(self.__divMovable,"nsAnimateGhost");
				self.__dragEndCleanUp();
				self.__resetChildren();
			};
			if(this.__config.enableCloneMode)
			{
				this.util.addStyleClass(this.__divMovable,"nsAnimateGhost");
				var transition = new this.util.transition(this.__divMovable,transitionEndCallback);
		    	var objSourceNSObject = orignalNode["nsObject"];
		    	this.__divMovable.style.left = (objSourceNSObject.position.left) + "px";
		    	this.__divMovable.style.top = (objSourceNSObject.position.top ) + "px";
			}
			else
			{
				transitionEndCallback();
			}
		}
	};
	
	NSDragDrop.prototype.__resetChildren = function()
	{
		var arrChildNode = this.__config.container.getElementsByTagName(this.__config.childNodeType);
		var childNode = null;
		for (var count = 0; count < arrChildNode.length; count++) 
		{
			childNode = arrChildNode[count];
			this.util.removeStyleClass(childNode,this.__config.nodeDragHoverClass);
		}
	};
	
	NSDragDrop.prototype.__clearHoldTime = function()
	{
		if(this.__holdTimeoutInterval > -1)
		{
			clearTimeout(this.__holdTimeoutInterval);
		}
		this.__holdTimeoutInterval = -1;
		this.__removeDocumentHoldListener();
	};
	
	NSDragDrop.prototype.__insertNode = function(node,index,currentElement,nodeData)
	{
		if(this.__config.insertNodeCallback)
		{
			this.__config.insertNodeCallback(this.__config.container,node,index,currentElement,nodeData);
		}
		else
		{
			var container = this.__config.container;
			if(this.__parentContainerType.toLowerCase() === "table")
			{
				currentElement.parentNode.insertBefore(node,currentElement);
			}
			else
			{
				container.insertBefore(node,currentElement);
			}
		}
		this.__initializeChildren();
	};
	
	NSDragDrop.prototype.__moveNode = function(node,index,currentElement,nodeData)
	{
		if(this.__config.moveNodeCallback)
		{
			this.__config.moveNodeCallback(this.__config.container,node,index,currentElement,nodeData);
		}
		else
		{
			var container = this.__config.container;
			if(this.__parentContainerType.toLowerCase() === "table")
			{
				currentElement.parentNode.insertBefore(node,currentElement);
			}
			else
			{
				//this.util.insertAfterElement(currentElement,node);
				container.insertBefore(node,currentElement);
			}
		}
		this.__initializeChildren();
	};
	
	NSDragDrop.prototype.__removeNode = function(node,nodeData)
	{
		if(this.__config.removeNodeCallback)
		{
			this.__config.removeNodeCallback(this.__config.container,node,nodeData);
		}
		else
		{
			var container = this.__config.container;
			if(this.__parentContainerType.toLowerCase() === "table")
			{
				node.parentNode.removeChild(node);
			}
			else
			{
				//if not clone mode then element is already removed
				if(this.__config.enableCloneMode)
				{
					container.removeChild(node);
				}
			}
		}
		this.__initializeChildren();
	};
	
	NSDragDrop.prototype.__getTargetElementDetails = function(event,orignalNode)
	{
		var targetX = event.pageX - document.documentElement.scrollLeft;
	    var targetY = event.pageY - (window.pageYOffset || document.documentElement.scrollTop);
	    var targetElement = document.elementFromPoint(targetX, targetY);
	    var parent = null;
	    var childNodeType = null;
	    var arrElement = [];
	    var prevElement = null;
	    while(this.util.isElement(targetElement) && targetElement.tagName !== "HTML" && targetElement.tagName !== "BODY")
	    {
	    	if(targetElement === prevElement)
	    	{
	    		//console.log("Stop");
	    	}
	    	prevElement = targetElement;
	    	//console.log(targetElement.tagName + "," + targetElement.textContent);
	    	if(targetElement.tagName === this.__config.childNodeType)
	    	{
	    		childNodeType = targetElement;
	    	}
	    	else if(this.__parentContainerType.toLowerCase() === "table")
	    	{
	    		childNodeType = this.util.findParent(targetElement,this.__config.childNodeType);
	    		if(!childNodeType)
	    		{
	    			childNodeType = this.util.findChild(targetElement,this.__config.childNodeType);
	    		}
	    	}
	    	childNodeType = this.util.getWebComponentElement(childNodeType);
	    	if(childNodeType && childNodeType !== orignalNode && childNodeType["nsObject"] && childNodeType["nsObject"]["dropEnabled"])
	    	{
	    		targetElement = childNodeType;
	    		break;
	    	}
	    	arrElement.push({element:targetElement,display:targetElement.style.display});
	    	targetElement.style.display = "none";//pointerEvents = "none";
	    	
	    	targetElement = document.elementFromPoint(targetX, targetY);
	    }
	    for(var count = 0;count < arrElement.length;count++)
	    {
	    	arrElement[count].element.style.display = arrElement[count].display;//pointerEvents = "";
	    }
	    if(!this.util.isElement(targetElement) || targetElement.tagName === "HTML")
	    {
	    	targetElement = null;
	    }
	    if(targetElement)
	    {
	        if(!this.util.hasStyleClass(targetElement,this.__config.nodeDraggingClass))
	    	{
	        	//if not child then check parent
	        	var tmpTarget = targetElement.querySelector("." + this.__config.nodeDraggingClass);
	        	if(!tmpTarget)
	        	{
	        		tmpTarget = this.util.findParentBySelector(targetElement,"." + this.__config.nodeDraggingClass);
	        	}
	        	if(tmpTarget)
	        	{
	        		targetElement = tmpTarget;
	        	}
	    	}
	        if(targetElement["nsObject"] && targetElement["nsObject"]["parent"])
	    	{
	        	parent = targetElement["nsObject"]["parent"];
	    	}
	    }
	    return {element:targetElement,parent:parent,x:targetX,y:targetY};
	};
	
	NSDragDrop.prototype.__getPlaceholderDetails = function(event)
	{
		var targetX = event.pageX - document.documentElement.scrollLeft;
	    var targetY = event.pageY - (window.pageYOffset || document.documentElement.scrollTop);
		return {element:this.__compPlaceholder,parent:this.__compPlaceholder.parentNode,x:targetX,y:targetY};
	};
	
	NSDragDrop.prototype.__cloneNode = function(node)
	{
		var id = this.__getID();
		var divMovable = this.util.createDiv(id + "clonedItem", "nsDraggableCloneItem");
		var clonedNode = null;
		var rectContainer = this.__config.container.getBoundingClientRect();
		if(this.__config.createCloneCallback)
		{
			var containerConfiguration = {width:rectContainer.width,height:rectContainer.height};
			clonedNode = this.__config.createCloneCallback(node,containerConfiguration);
			clonedNode.setAttribute("id","comp" + id + "ClonedNode");
			divMovable.appendChild(clonedNode);
		}
		else
		{
			var container = this.__config.container.cloneNode(false);
			container.setAttribute("id","comp" + id + "ClonedContainer");
			if(this.__config.enableCloneMode)
			{
				clonedNode = node.cloneNode(true);
				clonedNode.setAttribute("id","comp" + id + "ClonedNode");
			}
			else
			{
				clonedNode = node;
			}
			container.appendChild(clonedNode);
			container.style.width = rectContainer.width + "px";
			try
			{
				divMovable.appendChild(container);
			}
			catch(error)
			{
				this.util.getWebComponentElement(divMovable).appendChild(container);
				//divMovable.appendChild(container);
			}
		}
		document.body.appendChild(divMovable);
		if (divMovable.setCapture) 
		{
			divMovable.setCapture();
		}
		if(node.nsObject)
		{
			var objCloned = {};//this.util.cloneObject(node.nsObject);
			objCloned.orignalNode = node;
			divMovable.nsObject = objCloned;
			clonedNode.nsObject = objCloned;
		}
		return divMovable;
	};
	
	NSDragDrop.prototype.__createPlaceholder = function(node) 
	{
		var placeHolder = null;
		if(this.__config.createPlaceholderCallback)
		{
			placeHolder = this.__config.createPlaceholderCallback(node);
		}
		else
		{
			placeHolder = this.util.createElement(this.__config.childNodeType);
			placeHolder.className  = node.className;
			this.util.addStyleClass(placeHolder,"nsDraggablePlaceholder");
			var rect = node.getBoundingClientRect();
			placeHolder.style.width = rect.width + "px";
			placeHolder.style.height = rect.height + "px";
		}
		return placeHolder;
	};
	
	NSDragDrop.prototype.__isNodeDraggable = function(node) 
	{
		var retValue = true;
		if(node)
		{
			if(this.__config.nodeDraggableCallback)
			{
				retValue = this.__config.nodeDraggableCallback(node);
			}
		}
		return retValue;
	};
	
	NSDragDrop.prototype.__isNodeDroppable = function(node) 
	{
		var retValue = true;
		if(node)
		{
			node = this.util.findParent(node,this.__config.childNodeType);
			if(this.__config.nodeDroppableCallback)
			{
				retValue = this.__config.nodeDroppableCallback(node);
			}
		}
		return retValue;
	};
	
	NSDragDrop.prototype.__insertBefore = function(targetElement) 
	{
		if(this.__compPlaceholder && targetElement)
		{
			// Ensure the placeholder is visible in the target (unless it's a table row)
		    if (this.util.getStyleValue(this.__compPlaceholder,"display") !== 'table-row') 
		    {
		    	this.__compPlaceholder.style.display = "block";
		    }
		    if(!this.__config.enableCloneMode)
		    {
		    	targetElement.parentNode.insertBefore(this.__compPlaceholder,targetElement);
			    //dragItemInfo.moveTo(targetScope.sortableScope, targetScope.index());
		    }
		}
	};
	
	NSDragDrop.prototype.__insertAfter = function(targetElement) 
	{
		if(this.__compPlaceholder && targetElement)
		{
			// Ensure the placeholder is visible in the target (unless it's a table row)
		    if (this.util.getStyleValue(this.__compPlaceholder,"display") !== 'table-row') 
		    {
		    	this.__compPlaceholder.style.display = "block";
		    }
		    if(!this.__config.enableCloneMode)
		    {
		    	this.util.insertAfterElement(targetElement,this.__compPlaceholder);
		    	//dragItemInfo.moveTo(targetScope.sortableScope, targetScope.index() + 1);
		    }
		    
		}
	};
	
	NSDragDrop.prototype.__getPlaceHolderIndex = function(targetElement) 
	{
		if(targetElement)
		{
			if(this.util.hasStyleClass(targetElement,"nsDraggablePlaceholder"))
			{
				return 0;
		    }
			var arrChildNode = targetElement.getElementsByTagName(this.__config.childNodeType);
			var childNode = null;
			for (var count = 0; count < arrChildNode.length; count++) 
			{
				childNode = arrChildNode[count];
				if(this.util.hasStyleClass(childNode,"nsDraggablePlaceholder"))
				{
					return count;
				}
			}
		}
	    return -1;
	};
	
	NSDragDrop.prototype.__isSameContainer = function(container) 
	{
		if(container && container.nsObject) 
		{
			return this.__config.container.nsObject["id"] === container.nsObject["id"];
		}
		return false;
	};
	
	NSDragDrop.prototype.__dragEndCleanUp = function() 
	{
		this.util.makeBodySelectable();
		this.__isDragging = false;
		if(this.__divMovable)
		{
			if(this.__divMovable["nsObject"] && this.__divMovable["nsObject"]["orignalNode"])
			{
				var orignalNode = this.__divMovable["nsObject"]["orignalNode"];
				this.util.removeStyleClass(orignalNode,this.__config.nodeDragHoverClass);
				this.util.removeStyleClass(orignalNode,this.__config.nodeDraggingClass);
			}
			this.__divMovable.parentNode.removeChild(this.__divMovable);
			this.__divMovable = null;
		}
		if(this.__lastTarget)
	    {
	    	this.util.removeStyleClass(this.__lastTarget,this.__config.nodeDragHoverClass);
	    	this.__lastTarget = null;
	    }
		if(this.__compPlaceholder)
		{
			this.__compPlaceholder.parentNode.removeChild(this.__compPlaceholder);
			this.__compPlaceholder = null;
		}
		this.__itemPosition = null;
		this.__objSelectedItem = {scrollableContainer:null,containment:null};
	};
	
	NSDragDrop.prototype.__getOffset = function(element,scrollableContainer) 
	{
		var boundingClientRect = element.getBoundingClientRect();
	    if (!scrollableContainer) 
	    {
	    	scrollableContainer = document.documentElement;
	    }
	    var retValue = { width: boundingClientRect.width || element.offsetWidth,
	    	height: boundingClientRect.height || element.offsetHeight,
	    	top: boundingClientRect.top + (window.pageYOffset || scrollableContainer.scrollTop - scrollableContainer.offsetTop),
	    	left: boundingClientRect.left + (window.pageXOffset || scrollableContainer.scrollLeft - scrollableContainer.offsetLeft)
	    };
	    return retValue;
	};
	
	NSDragDrop.prototype.__positionStarted = function(event,target,scrollableContainer) 
	{
		var position = {};
		position.offsetX = event.pageX - this.__getOffset(target, scrollableContainer).left;
		position.offsetY = event.pageY - this.__getOffset(target, scrollableContainer).top;
		position.startX = position.lastX = event.pageX;
		position.startY = position.lastY = event.pageY;
		position.nowX = position.nowY = position.distX = position.distY = position.dirAx = 0;
		position.dirX = position.dirY = position.lastDirX = position.lastDirY = position.distAxX = position.distAxY = 0;
	    return position;
	};
	
	NSDragDrop.prototype.__calculatePosition = function(position,event) 
	{
		 position.lastX = position.nowX;
	     position.lastY = position.nowY;
	
	     // mouse position this events
	     position.nowX = event.pageX;
	     position.nowY = event.pageY;
	
	     // distance mouse moved between events
	     position.distX = position.nowX - position.lastX;
	     position.distY = position.nowY - position.lastY;
	
	     // direction mouse was moving
	     position.lastDirX = position.dirX;
	     position.lastDirY = position.dirY;
	
	     // direction mouse is now moving (on both axis)
	     position.dirX = position.distX === 0 ? 0 : position.distX > 0 ? 1 : -1;
	     position.dirY = position.distY === 0 ? 0 : position.distY > 0 ? 1 : -1;
	
	     // axis mouse is now moving on
	     var newAx = Math.abs(position.distX) > Math.abs(position.distY) ? 1 : 0;
	
	     // calc distance moved on this axis (and direction)
	     if (position.dirAx !== newAx) 
	     {
	       position.distAxX = 0;
	       position.distAxY = 0;
	     } 
	     else 
	     {
	       position.distAxX += Math.abs(position.distX);
	       if (position.dirX !== 0 && position.dirX !== position.lastDirX) 
	       {
	         position.distAxX = 0;
	       }
	
	       position.distAxY += Math.abs(position.distY);
	       if (position.dirY !== 0 && position.dirY !== position.lastDirY) 
	       {
	         position.distAxY = 0;
	       }
	     }
	     position.dirAx = newAx;
	};
	
	NSDragDrop.prototype.__movePosition = function(event,element,position,container,cssPosition,scrollableContainer) 
	{
		var bounds;
	    var useRelative = (cssPosition === 'relative');
	    element.x = event.pageX - position.offsetX;
	    element.y = event.pageY - position.offsetY;
	
	    if (container) 
	    {
	      bounds = this.__getOffset(container, scrollableContainer);
	      if (useRelative) 
	      {
	        // reduce positioning by bounds
	        element.x -= bounds.left;
	        element.y -= bounds.top;
	
	        // reset bounds
	        bounds.left = 0;
	        bounds.top = 0;
	      }
	
	      if (element.x < bounds.left) 
	      {
	    	  element.x = bounds.left;
	      } 
	      else if (element.x >= bounds.width + bounds.left - this.__getOffset(element).width) 
	      {
	    	  element.x = bounds.width + bounds.left - this.__getOffset(element).width;
	      }
	      if (element.y < bounds.top) 
	      {
	    	  element.y = bounds.top;
	      } 
	      else if (element.y >= bounds.height + bounds.top - this.__getOffset(element).height) 
	      {
	    	  element.y = bounds.height + bounds.top - this.__getOffset(element).height;
	      }
	    }
	    element.style.left = element.x + 'px';
	    element.style.top = element.y + 'px';
	    
	    this.__calculatePosition(position, event);
	};
	
	NSDragDrop.prototype.__getID = function()
	{
		if(!this.__id)
		{
			if(this.__config.container.hasAttribute("id"))
			{
				this.__id = this.__config.container.getAttribute("id");
			}
			else if(this.__config.container.hasAttribute("name"))
			{
				this.__id = this.__config.container.getAttribute("name");
			}
			else
			{
				this.__id = "comp" + this.util.getUniqueId();
			}
		}
		return this.__id;
	};
	
	return NSDragDrop;
})();
nsModuleExport(this,"NSDragDrop",NSDragDrop);"use strict";
var NSFilter = (function()
{
	function NSFilter(data,filter,setting,recordLimit,isHierarchical,childField,filterFunction,hierarchyFilterChildren,arrIgnoreKeysInCloneDataSource) 
	{
		this.EXACT = "exact";
		this.STARTS_WITH = "startsWith";
		this.ENDS_WITH = "endsWith";
		this.CONTAINS = "contains";
		
		this.IS_FOUND_FIELD = "__nsFilter__found";
		
		this.util = new NSUtil();
		this.__data = data;
		this.__filter = filter;
		this.__setting = setting;
		this.__recordLimit = (parseInt(recordLimit) > 0) ? recordLimit : -1;
		this.__isHierarchical = this.util.isUndefined(isHierarchical) ? false : Boolean.parse(isHierarchical);
		this.__childField = childField ? childField : "children";
		this.__filterFunction = filterFunction;
		this.__hierarchyFilterChildren = hierarchyFilterChildren;
		this.__arrIgnoreKeysInCloneDataSource = arrIgnoreKeysInCloneDataSource;
		this.__ignoreSameLevelNode = true;
	}
	
	NSFilter.prototype.execute = function(data,filter,setting,recordLimit,isHierarchical,childField,filterFunction,hierarchyFilterChildren,arrIgnoreKeysInCloneDataSource) 
	{ 
		data = data ? data : this.__data;
		filter = filter ? filter : this.__filter;
		setting = setting ? setting : this.__setting;
		recordLimit = (parseInt(recordLimit) > 0) ? recordLimit : this.__recordLimit;
		isHierarchical = this.util.isUndefined(isHierarchical) ? Boolean.parse(this.__isHierarchical) : Boolean.parse(isHierarchical);
		childField = childField ? childField : this.__childField;
		filterFunction = filterFunction ? filterFunction : this.__filterFunction;
		hierarchyFilterChildren = hierarchyFilterChildren ? hierarchyFilterChildren : this.__hierarchyFilterChildren;
		arrIgnoreKeysInCloneDataSource = this.util.isUndefinedOrNull(arrIgnoreKeysInCloneDataSource) ? this.__arrIgnoreKeysInCloneDataSource : arrIgnoreKeysInCloneDataSource;
		if(data && filter)
		{
			var dataSource = data.slice(0);
			var arrFilter = [];
			var self = this;
			var callFilterFunction = function(source,level,parentItem)
			{
				var arrReturn = [];
				for (var count = 0; count < source.length; count++) 
				{
					var item = source[count];
					var found = false;
					if(isHierarchical && item[childField] && item[childField].length > 0 )
					{
						var arrChild = callFilterFunction(item[childField],level + 1,item);
						if(arrChild && arrChild.length > 0)
						{
							found = true;
							if(self.__ignoreSameLevelNode)
							{
					            item[childField] = arrChild;
							}
							arrReturn.push(item);
						}
					}
					if(!found && self.__filterItem(item,filter,setting,isHierarchical,childField,parentItem,filterFunction))
					{
						if(isHierarchical && hierarchyFilterChildren)
						{
							var arrChildren = item[childField];
							if(arrChildren && arrChildren.length > 0)
							{
								var childItem = null;
								var childLength = arrChildren.length;
								for(var childCount = childLength - 1;childCount > -1;childCount--)
								{
									childItem = arrChildren[childCount];
									if(childItem)
									{
										if(!hierarchyFilterChildren(childItem,childCount,childItem[self.IS_FOUND_FIELD],filter,setting,item))
										{
											arrChildren.splice(childCount, 1);
										}
									}
								}
							}
						}
						found = true;
						arrReturn.push(item);
						if(!isHierarchical && recordLimit > 0 && arrReturn.length >= recordLimit)
						{
							break;
						}
					}
				}
				//return false;
				return arrReturn;
			};
			var callNonHierarchicalFilterFunction = function(source)
			{
				var arrReturn = [];
				for (var count = 0; count < source.length; count++) 
				{
					var item = source[count];
					if(self.__filterItemNonHierarchical(item,filter,setting,filterFunction))
					{
						arrReturn.push(item);
					}
				}
				return arrReturn;
			};
			dataSource = this.util.cloneObject(dataSource,isHierarchical,[],arrIgnoreKeysInCloneDataSource);
			if(isHierarchical)
			{
				arrFilter = callFilterFunction(dataSource,1,null);
			}
			else
			{
				arrFilter = callNonHierarchicalFilterFunction(dataSource);
			}
			return arrFilter;
		}
		return data;
	};
	
	NSFilter.prototype.__filterItemNonHierarchical = function(item,filter,setting,filterFunction) 
	{
		var retValue = false;
		if(filterFunction)
		{
			retValue = filterFunction(item,filter,setting);
			this.__setItem(item,retValue);
			return retValue;
		}
		else if(filter instanceof Function) 
	    {
			retValue = filter(item,setting);
	        this.__setItem(item,retValue);
	        return retValue;
	    }
	    else if(filter instanceof Array) 
	    {
	        for (var count = 0; count < filter.length; ++count) 
	        {
	            if (this.__filterItemNonHierarchical(item,filter[count],setting,filterFunction))
	            {
	            	this.__setItem(item,true);
	            	return true;
	            }
	        }
	        return false;
	    }
	    else if(setting.type === "date" && filter)
	    {
	        return this.__filterDate(item,filter,setting);
	    }
	    else if(typeof(item) === "string" && filter)
	    {
	        return this.__filterString(item,filter,setting);
	    }
	    else if (item === item + 0 && filter)
	    {
	        return this.__filterNumeric(item,filter);
	    }
	    else if(typeof (filter) === "object") 
	    {
	        for(var key in filter) 
	        {
	        	var tempSetting = {};
	        	if(setting && setting[key])
	        	{
	        		tempSetting = setting[key];
	        	}
	            if(!this.__filterItemNonHierarchical(item[key],filter[key],tempSetting,filterFunction))
	            {
	            	return false;
	            }
	        }
	        this.__setItem(item,true);
	        return true;
	    }
		retValue = (filter == item);
	    this.__setItem(item,retValue);
	    return retValue;
	};
	
	NSFilter.prototype.__filterItem = function(item,filter,setting,isHierarchical,childField,parentItem,filterFunction) 
	{
		var retValue = false;
		if(filterFunction)
		{
			retValue = filterFunction(item,filter,setting,isHierarchical,childField,parentItem);
			this.__setItem(item,retValue);
			return retValue;
		}
		else if(filter instanceof Function) 
	    {
			retValue = filter(item,setting);
	        this.__setItem(item,retValue);
	        return retValue;
	    }
	    else if(filter instanceof Array) 
	    {
	        for (var count = 0; count < filter.length; ++count) 
	        {
	            if (this.__filterItem(item,filter[count],setting,isHierarchical,childField,parentItem,filterFunction))
	            {
	            	this.__setItem(item,true);
	            	return true;
	            }
	        }
	        return false;
	    }
	    else if(setting.type === "date" && filter)
	    {
	        return this.__filterDate(item,filter,setting);
	    }
	    else if(typeof(item) === "string" && filter)
	    {
	        return this.__filterString(item,filter,setting);
	    }
	    else if (item === item + 0 && filter)
	    {
	        return this.__filterNumeric(item,filter);
	    }
	    else if(typeof (filter) === "object") 
	    {
	        for(var key in filter) 
	        {
	        	if(isHierarchical && key === childField)
	        	{
	        		continue;
	        	}
	        	var tempSetting = {};
	        	if(setting && setting[key])
	        	{
	        		tempSetting = setting[key];
	        	}
	            if(!this.__filterItem(item[key],filter[key],tempSetting,isHierarchical,childField,parentItem,filterFunction))
	            {
	            	return false;
	            }
	        }
	        this.__setItem(item,true);
	        return true;
	    }
		retValue = (filter == item);
	    this.__setItem(item,retValue);
	    return retValue;
	};
	
	NSFilter.prototype.__setItem = function(item,isFound)
	{
		if(item && typeof (item) === "object" && isFound)
		{
			item[this.IS_FOUND_FIELD] = true;
		}
	};
	
	NSFilter.prototype.__filterNumeric= function(value,searchParam)
	{
		var retValue = false;
		value = parseFloat(value);
		if(!isNaN(value))
		{
			if(/<=/.test(searchParam)) // first checks if there is an operator (<,>,<=,>=)
			{
				retValue = (value <= parseFloat(searchParam.replace(/<=/,"")));
			}
			else if(/>=/.test(searchParam))
			{
				retValue = (value >= parseFloat(searchParam.replace(/>=/,"")));
			}
			else if(/</.test(searchParam))
			{
				retValue = (value < parseFloat(searchParam.replace(/</,"")));
			}
			else if(/>/.test(searchParam))
			{
				retValue = (value > parseFloat(searchParam.replace(/>/,"")));
			}
			else
			{
				retValue = (value === parseFloat(searchParam));
			}
		}
		return retValue;
	};
	
	NSFilter.prototype.__filterDate= function(value,searchParam,setting)
	{
		var retValue = false;
		var self = this;
		var matchValue = function(compareValue,opt)
		{
			var compValue = false;
			if(self.util.isUndefinedOrNull(value))
			{
				compValue = false;
			}
			else
			{
				var newVal = self.__getDate(value,setting.cellFormat);
				if(newVal)
				{
					newVal.setHours(0, 0, 0, 0);
					compareValue.setHours(0, 0, 0, 0);
					switch(opt)
					{
						case "equals":
							if (compareValue.getTime() === newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
						case "greaterThan":
							if (compareValue.getTime() < newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
						case "lessThan":
							if (compareValue.getTime() > newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
						case "notEqual":
							if (compareValue.getTime() != newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
					}
				}
				else
				{
					self.util.warning("NSFilter",value + " cannot be converted to date Object for given cell format");
					compValue = false;
				}
			}
			return compValue;
		};
		var processDate = function(date,type)
		{
			var compValue = false;
			if(date && matchType1)
			{
				if(!date || !Object.prototype.toString.call(date) === '[object Date]')
				{
					compValue = true;
				}
				else if(setting.comparator)
				{
					compValue = setting.comparator(value,date,setting);
				}
				else
				{
					compValue = matchValue(date,type);
				}
			}
			return compValue;
		};
		if(setting.matchType1 || setting.matchType2)
		{
			var matchType1 = setting.matchType1;
			var firstDate = setting.firstDate;
			var operation = setting.operation;
			var matchType2 = setting.matchType2;
			var secondDate = setting.secondDate;
			if(this.util.isUndefinedOrNull(value))
			{
				retValue = false;
			}
			else if(firstDate && secondDate && matchType1 && matchType2 && operation)
			{
				var firstVal = processDate(firstDate,matchType1);
				var secondVal = processDate(secondDate,matchType2);
				switch(operation)
				{
					case "and":
						retValue = (firstVal && secondVal);
					break;
					case "or":
						retValue = (firstVal || secondVal);
					break;
				}
			}
			else if(firstDate && matchType1)
			{
				retValue = processDate(firstDate,matchType1);
			}
			else if(secondDate && matchType2)
			{
				retValue = processDate(secondDate,matchType2);
			}
			else
			{
				retValue = true;
			}
		}
		else
		{
			if(!searchParam || !Object.prototype.toString.call(searchParam) === '[object Date]')
			{
				retValue = true;
			}
			else if(setting.comparator)
			{
				retValue = setting.comparator(value,searchParam,setting);
			}
			else if(this.util.isUndefinedOrNull(value))
			{
				retValue = false;
			}
			else
			{
				retValue = matchValue(searchParam,"equals");
			}
		}
		return retValue;
	};
	
	NSFilter.prototype.__filterString= function(value,searchParam,setting)
	{
		var regExp = null;
		var regExpModifier = "g";
		var startWithChar = "(^)";
		var endsWithChar = "($)";
		var searchString = "";
		var isCaseSensitive = false;
		var isMultiline = false;
		var matchType = this.CONTAINS;
		if(setting)
		{
			isCaseSensitive = Boolean.parse(setting["caseSensitive"]);
			isMultiline = Boolean.parse(setting["multiline"]);
			matchType = setting["matchType"] ? setting["matchType"] : matchType;
		}
		if(!isCaseSensitive)
		{
			regExpModifier += "i";
		}
		if(isMultiline)
		{
			regExpModifier += "m";
		}
		searchParam = this.__removeSpecialCharacter(searchParam);
		if(matchType === this.EXACT)
		{
			searchString = startWithChar + searchParam + endsWithChar;
		}
		else if(matchType === this.STARTS_WITH)
		{
			searchString = startWithChar + searchParam;
		}
		else if(matchType === this.ENDS_WITH)
		{
			searchString = searchParam + endsWithChar;
		}
		else 
		{
			searchString = searchParam;
		}
		regExp = new RegExp(searchString,regExpModifier);
		return regExp.test(value);
	};
	
	NSFilter.prototype.__removeSpecialCharacter = function(text)
	{
		function replaceEscape(char)
		{
			if(text)
			{
				var exp = new RegExp("\\" + char,"g");
				text = text.replace(exp,"\\" + char);
			}
		}
		var specialChar = ['\\','[','^','$','.','|','?','*','+','(',')'];
		for(var count = 0;count < specialChar.length;count++) 
		{
			replaceEscape(specialChar[count]);
		}
		return text;
	};
	
	//ref from : https://stackoverflow.com/questions/7445328/check-if-a-string-is-a-date-value
	NSFilter.prototype.__getDate = function(value,arrFormat) 
	{
		if(value)
		{
			var dateFormat;
		    if (Object.prototype.toString.call(value) === '[object Date]') 
		    {
		        return value;
		    }
		    if(arrFormat)
		    {
		    	var dateUtil = new NSDateUtil();
		    	if(!this.util.isArray(arrFormat))
		    	{
		    		arrFormat = [arrFormat];
		    	}
		    	for(var count = 0;count < arrFormat.length;count++)
		    	{
		    		var format = arrFormat[count];
		    		var date = dateUtil.parseString(value,format);
		    		if(date)
		    		{
		    			return date;
		    		}
		    	}
		    }
		    else
		    {
		    	if (typeof value.replace === 'function') 
			    {
			        value.replace(/^\s+|\s+$/gm, '');
			    }
			    dateFormat = /(^\d{1,4}[\.|\\/|-]\d{1,2}[\.|\\/|-]\d{1,4})(\s*(?:0?[1-9]:[0-5]|1(?=[012])\d:[0-5])\d\s*[ap]m)?$/;
			    if(dateFormat.test(value))
			    {
			    	return new Date(value);//Date.parse(value);
			    }
		    }
		}
	    return null;
	};
	
	return NSFilter;
})();
nsModuleExport(this,"NSFilter",NSFilter); "use strict"; 
var NSMenu = (function()
{
	function NSMenu(setting) 
	{
		this.util = new NSUtil();
		this.DEFAULT_POSITION = this.util.POS_BOTTOMRIGHT;
		
		this.__setting = setting;
		this.__config = null;
		
		this.__id = null;
		this.__popUp = null;
		this.__nsPopUp = null;
		this.__fieldItem = null;
		this.__fieldItemChild = null;
		this.__fieldChild = "children";
		this.__isInternalCall = false;
		this.__suppressDocumentHandler = false;
		
		this.__documentClickRef = null;
		this.__documentKeyUpRef = null;
		this.__lastSelectedTarget = null;
		
		this.__initialize();
	}
	
	NSMenu.prototype.create = function (dataSource) 
	{ 
		if(dataSource && (this.__config.createRunTime || this.__isInternalCall))
		{
			if(this.__popUp)
			{
				this.remove();
			}
			this.__isInternalCall = false;
			this.__config.dataSource = dataSource;
			this.__popUp = this.__createElement(true,this.__config.dataSource);
			this.util.addStyleClass(this.__nsPopUp,"nsMainMenu");
		}
	};
	
	NSMenu.prototype.remove = function () 
	{ 
		if(this.__config.createRunTime || this.__isInternalCall)
		{
			this.__isInternalCall = false;
			this.__nsPopUp.remove();
			this.__popUp = null;
		}
	};
	
	NSMenu.prototype.show = function (event) 
	{ 
		event = this.util.getEvent(event);
		this.__nsPopUp.hideOtherNSPopUp();
		if(this.__config.createRunTime)
		{
			this.__isInternalCall = true;
			var dataSource = null;
			if(this.__config.sourceProvider)
			{
				dataSource = this.__config.sourceProvider(this.__lastSelectedTarget);
			}
			if(dataSource && dataSource.length > 0)
			{
				this.create(dataSource);
			}
			else
			{
				this.util.preventDefault(event);
				return;
			}
		}
		this.__nsPopUp.show();
		this.__nsPopUp.placePopUp(event);
		if(!this.__documentClickRef)
		{
			this.__documentClickRef = this.__documentClickHandler.bind(this);
			this.util.addEvent(document.documentElement,"click", this.__documentClickRef);
		}
		if(!this.__documentKeyUpRef)
		{
			this.__documentKeyUpRef = this.__documentKeyUpHandler.bind(this);
			this.util.addEvent(document.documentElement,"keyup", this.__documentKeyUpRef);
		}
		this.util.preventDefault(event);
	};
	NSMenu.prototype.hide = function() 
	{
		this.__lastSelectedTarget = null;
		this.__hideAllSubMenus();
		if(this.__config.createRunTime)
		{
			this.__isInternalCall = true;
			this.remove();
		}
		else
		{
			this.__nsPopUp.hide();
		}
		if(this.__documentClickRef)
		{
			this.util.removeEvent(document.documentElement,"click", this.__documentClickRef, false);
			this.__documentClickRef = null;
		}
		if(this.__documentKeyUpRef)
		{
			this.util.removeEvent(document.documentElement,"keyup", this.__documentKeyUpRef, false);
			this.__documentKeyUpRef = null;
		}
	};
	
	NSMenu.prototype.__initialize = function ()
	{
		if(this.__setting)
		{
			//eventHandler:extra eventHandler which developer wants to execute on the event i.e. click,customEvent etc
			this.__config = {
					parent: this.__setting["parent"] || null,
					dataSource: this.__setting["dataSource"] || null,
					isContextMenu: (this.util.isUndefined(this.__setting["isContextMenu"]) || this.__setting["isContextMenu"] === null) ? true : Boolean.parse(this.__setting["isContextMenu"]),
					eventType: this.__setting["eventType"] || "click",
					createRunTime: (this.util.isUndefined(this.__setting["createRunTime"]) || this.__setting["createRunTime"] === null) ? false : Boolean.parse(this.__setting["createRunTime"]),
					sourceProvider: this.__setting["sourceProvider"] || null,
					targetType: this.__setting["targetType"] || null,
					defaultHandler: (this.__setting["defaultHandler"] ? this.util.getFunction(this.__setting["defaultHandler"]) : null),
					eventHandler: (this.__setting["eventHandler"] ? this.util.getFunction(this.__setting["eventHandler"]) : null),
					position: this.__setting["position"] || this.DEFAULT_POSITION,
					width: parseInt(this.__setting["width"]) || -1
				};
			if(this.__config.parent)
			{
				var popUpSetting = {id:this.__getID() + "menu",type:"ul",width:this.__config.width,position:this.__config.position};
				this.__nsPopUp = new this.util.nsPopUp(popUpSetting);
				this.__fieldItem = this.__getID() + "_item";
				this.__fieldItemChild = this.__getID() + "_child";
				if(!this.__config.createRunTime)
				{
					this.__isInternalCall = true;
					this.create(this.__config.dataSource);
				}
				if(this.__config.isContextMenu)
				{
					this.util.addEvent(this.__config.parent,"contextmenu", this.__parentContextMenuHandler.bind(this));
				}
				else
				{
					this.util.addEvent(this.__config.parent,this.__config.eventType, this.__parentClickHandler.bind(this),false);
				}
			}
		}
	};
	
	NSMenu.prototype.__createElement = function(isRoot,dataSource) 
	{
		var parentNode = null;
		if(dataSource && dataSource.length > 0)
		{
			if(isRoot)
			{
				parentNode = this.__nsPopUp.create();
			}
			else
			{
				parentNode = document.createElement("ul"); 
				this.util.addStyleClass(parentNode,"nsMenu");
				if(this.__config.width > -1)
				{
					parentNode.style.width = this.__config.width + "px";
				}
			}
			for (var count = 0; count < dataSource.length; count++) 
			{
				var item = dataSource[count];
				this.__createItem(item,parentNode);
			}
		}
		return parentNode;
	};
	
	NSMenu.prototype.__createItem = function(item,parent)
	{
		var menuItem = null;
		if(item)
		{
			menuItem = document.createElement("li");
			this.util.addStyleClass(menuItem,"nsMenuItem");
			if(item["header"])
			{
				this.util.addStyleClass(menuItem,"nsHeader");
			}
			if(item["disabled"])
			{
				this.util.addStyleClass(menuItem,"nsDisabled");
			}
			var button = document.createElement("BUTTON");
			this.util.addStyleClass(button,"nsMenuButton");
			if(item["iconHTML"])
			{
				var spanIcon = document.createElement("span");
				this.util.addStyleClass(spanIcon,"nsMenuAlign");
				spanIcon.innerHTML = item["iconHTML"];
				button.appendChild(spanIcon);
			}
			var spanText = document.createElement("span");
			this.util.addStyleClass(spanText,"nsMenuText");
			spanText.appendChild(document.createTextNode(item["title"]));
			button.appendChild(spanText);
			menuItem.appendChild(button);
			this.util.addEvent(menuItem,"click",this.__itemClickHandler.bind(this));
			this.util.addEvent(menuItem,"mouseenter",this.__itemMouseOverHandler.bind(this));
			this.util.addEvent(menuItem,"mouseleave",this.__itemMouseOutHandler.bind(this));
			if(item[this.__fieldChild]) 
			{
				this.util.addStyleClass(menuItem,"nsSubMenu");
		    	var subMenu = this.__createElement(false,item[this.__fieldChild]);
		    	if(subMenu)
		    	{
		    		this.util.addStyleClass(subMenu,"nsSubMenuContainer");
			    	menuItem.appendChild(subMenu);
			    	item[this.__fieldItemChild] = subMenu;
			    	menuItem.setAttribute("hasChild",true);
		    	}
			}
			else
			{
				menuItem.setAttribute("hasChild",false);
			}
			if(parent)
			{
				parent.appendChild(menuItem);
				if(item["separatorBelow"])
				{
					var lineMenuItem = document.createElement("li");
					this.util.addStyleClass(lineMenuItem,"nsMenuSeparator");
					parent.appendChild(lineMenuItem);
				}
			}
			item[this.__fieldItem] = menuItem;
		}
		return menuItem;
	};
	
	NSMenu.prototype.__itemClickHandler = function(event) 
	{
		event = this.util.getEvent(event);
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"LI");
		var item = this.__getItem(target,this.__config.dataSource);
		if(item)
		{
			var handler = null;
			if(item["handler"])
			{
				handler = this.util.getFunction(item["handler"]);
			}
			if(!handler)
			{
				handler = this.__config.defaultHandler;
			}
			if(handler)
			{
				handler(this.__lastSelectedTarget,item);
			}
		}
		this.hide();
		event.stopImmediatePropagation();
	};
	
	NSMenu.prototype.__itemMouseOverHandler = function(event) 
	{
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"LI");
		if(target.getAttribute("hasChild") === "true")
		{
			var item = this.__getItem(target,this.__config.dataSource);
			if(item && item[this.__fieldItemChild])
			{
				var childMenu = item[this.__fieldItemChild];
				this.util.addStyleClass(childMenu,"nsShowMenu");
			}
		}
	};
	
	NSMenu.prototype.__itemMouseOutHandler = function(event) 
	{
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"LI");
		if(target.getAttribute("hasChild") === "true")
		{
			var item = this.__getItem(target,this.__config.dataSource);
			if(item && item[this.__fieldItemChild])
			{
				var childMenu = item[this.__fieldItemChild];
				this.util.removeStyleClass(childMenu,"nsShowMenu");
			}
		}
	};
	
	NSMenu.prototype.__documentClickHandler = function(event) 
	{
		event = this.util.getEvent(event);
		/*if(!this.__config.isContextMenu && this.__isParentPresent(event.target,this.__config.parent))
		{
			return;
		}*/
		//commenting this so that menu closes on click in Grid
		/*if(this.__suppressDocumentHandler)
		{
			this.__suppressDocumentHandler = false;
			return;
		}*/
		this.hide();
	};
	
	
	NSMenu.prototype.__documentKeyUpHandler = function(event) 
	{
		event = this.util.getEvent(event);
		if(event.keyCode === this.util.KEYCODE.ESC) 
		{
			this.hide();
		}
	};
	
	NSMenu.prototype.__parentContextMenuHandler = function(event)
	{
		if(this.__config.eventHandler)
		{
			this.__config.eventHandler(event);
		}
		this.__setLastSelectedTarget(this.util.getTarget(event));
		this.show(event);
	};
	
	NSMenu.prototype.__parentClickHandler = function(event)
	{
		if(this.__config.eventHandler)
		{
			this.__config.eventHandler(event);
		}
		this.__setLastSelectedTarget(this.util.getTarget(event));
		//below condition to make documentClickhandler aware that do not hide the menu,hence put only for click handler
		if(this.__config.eventType === "click")
		{
			this.__suppressDocumentHandler = true;
			event.stopPropagation();
		}
		this.show(event);
	};
	
	NSMenu.prototype.__getItem = function(objItem,dataSource)
	{
		if(objItem)
		{
			for (var count = 0; count < dataSource.length; count++) 
			{
				var item = dataSource[count];
				if(item[this.__fieldItem] == objItem)
				{
					return item;
				}
				if(item.hasOwnProperty(this.__fieldChild))
				{
					var childItem = this.__getItem(objItem,item[this.__fieldChild]);
					if(childItem)
					{
						return childItem;
					}
				}
			}
		}
		return null;
	};
	
	NSMenu.prototype.__hideAllSubMenus = function()
	{
		var arrSubMenus = this.__popUp.querySelectorAll("ul");
		if(arrSubMenus && arrSubMenus.length > 0)
		{
			var subMenu = null;
			for(var count = 0;count < arrSubMenus.length;count++)
			{
				subMenu = arrSubMenus[count];
				this.util.removeStyleClass(subMenu,"nsShowMenu");
			}
		}
	};
	
	NSMenu.prototype.__setLastSelectedTarget = function(target)
	{
		if(target && this.__config.targetType)
		{
			target = this.util.findParent(target,this.__config.targetType);
		}
		this.__lastSelectedTarget = target;
	};
	
	NSMenu.prototype.__getID = function()
	{
		if(!this.__id)
		{
			if(this.__config.parent.hasAttribute("id"))
			{
				this.__id = this.__config.parent.getAttribute("id");
			}
			else if(this.__config.parent.hasAttribute("name"))
			{
				this.__id = this.__config.parent.getAttribute("name");
			}
			else
			{
				this.__id = "comp" + this.util.getUniqueId();
			}
		}
		return this.__id;
	};
	
	NSMenu.prototype.__isParentPresent =  function(node,parentNode) 
	{
		while (node && node!== document.body)
		{
			if(node.id === parentNode.id) 
			{
				return true;
			}
			node = node.parentNode;
		}
		return false;
	};
	
	return NSMenu;
})();
nsModuleExport(this,"NSMenu",NSMenu); "use strict";
var NSVirtualScroll = (function()
{
	function NSVirtualScroll(setting) 
	{
		this.__setting = setting;
		this.util = null;
		this.__config = null;
		this.__internal = {};
		this.__objProp = {};
		this.__objSelectedProp = {};
		this.__domVariables = null;
		this.__doc = null;
		this.__win = null;
		this.__scrollHandlerRef = null;
		this.__resizeHandlerRef = null;
		
		this.__initialize();
	}
	
	NSVirtualScroll.prototype.dataSource = function(paramItems)
	{
		if(!this.util.isUndefinedOrNull(paramItems))
		{
			var reInit = false;
			if(!this.__internal.itemDimension)
			{
				reInit = true;
			}
			if(this.util.isNumber(paramItems))
			{
				this.__config.totalLength = parseInt(paramItems);
			}
			else if(this.util.isArray(paramItems))
			{
				this.__config.items = paramItems;
			}
			else
			{
				this.__config.totalLength = null;
				this.__config.items = [paramItems];
			}
            this.__internal.objItemComp = {};
            this.__internal.arrItem = [];
			if(reInit)
			{
                var item = this.__getItemAt(0);
				this.__internal.isItemHtml = this.util.isString(item);
				this.__setSize();
			}
			var scrollElement = this.__config.scrollElement;
			var scrollPos = scrollElement[this.__objSelectedProp.scroll];
			if(this.__internal.items && (this.__internal.items.length * this.__internal.itemDimension < scrollPos)) 
			{
				scrollElement[this.__objSelectedProp.scroll] = 0;
				this.__internal.lastPageNum = 0;
		    }
			this.__addItems();
			scrollElement[this.__objSelectedProp.scroll] = scrollPos;
		}
	};
	
	NSVirtualScroll.prototype.refresh = function(isReset)
	{
		var currItemSize = this.__internal.itemDimension;
		this.__setSize();
		var newItemSize = this.__internal.itemDimension;
		if((currItemSize != newItemSize) || isReset)
		{
			var criteria = null;
			if(this.__config.totalLength)
			{
				criteria = this.__config.totalLength;
			}
			else if(this.util.isArray(this.__config.items) && this.__config.items && this.__config.items.length)
			{
				criteria = this.__config.items;
			}
			else
			{
				criteria = 0;
			}
			this.dataSource(criteria);
		}
	};
	
	NSVirtualScroll.prototype.getScrollProgress = function()
	{
		var scrollPos = this.__internal.scrollPos;
		var itemSize = this.__internal.itemDimension;
		var totalSize = this.__internal.arrItem.length * itemSize;
		var progress = ((scrollPos / totalSize) * 100) || 0;
		return progress;
	};
	
	NSVirtualScroll.prototype.appendItems = function(arrItem)
	{
		this.__addNewItems(arrItem,false);
	};
	
	NSVirtualScroll.prototype.prependItems = function(arrItem)
	{
		this.__addNewItems(arrItem,true);
	};
	
	//assuming that size of all rows are same
	//if not same add offset
	//if variable Row size and utility user has original scroll Position then set scrollPosition and pass index as null
	NSVirtualScroll.prototype.scrollToIndex = function(index,animationRequired,offset,scrollPosition)
	{
		var arrItem = this.__internal.arrItem;
		if(arrItem && arrItem.length)
		{
			var scrollPos = null;
			if(!this.util.isUndefinedOrNull(index) && index > -1 && index < arrItem.length)
			{
				offset = this.util.isUndefinedOrNull(offset) ? 0 : parseInt(offset);
				scrollPos = (this.__internal.itemDimension * index) + offset;
			}
			else if(!this.util.isUndefinedOrNull(scrollPosition))
			{
				offset = 0;
				scrollPos = scrollPosition;
			}
			if(!this.util.isUndefinedOrNull(scrollPos))
			{
				var scrollElement = this.__config.scrollElement;
				if(animationRequired)
				{
					var animation = new this.util.animation(scrollElement,[
		       	  	    {
		       	  	      time: 500,
		       	  	      property:this.__objSelectedProp.scroll,
		       	  	      target: scrollPos,
		       	  	    }
		       	  	]);
		   	  	  	animation.animate();
				}
				else
				{
					scrollElement[this.__objSelectedProp.scroll] = scrollPos;
				}
			}
		}
	};
	
	//this function is used for updating items(dom elements) already generated 
	NSVirtualScroll.prototype.updateItems = function(updateCallback) 
	{
		if(this.__internal.arrItem && this.__internal.arrItem.length && updateCallback) 
		{
			var arrItem = this.__internal.arrItem;
			for(var count = 0;count < arrItem.length;count++) 
			{
				var item = arrItem[count]; 
				item = updateCallback(item);
				arrItem[count] = item;
			}
			this.__internal.arrItem = arrItem;
			this.__internal.origArrItem = this.__internal.arrItem;
		}
	}
	
	NSVirtualScroll.prototype.destroy = function()
	{
		var scrollElement = this.__config.scrollElement;
		var contentElement = this.__config.contentElement;
		if(this.__internal.contentTabIndex)
		{
			contentElement.setAttribute("tabindex",this.__internal.contentTabIndex);
		}
		this.util.removeStyleClass(scrollElement,"nsVirtualScrollElement nsVirtualScrollElement" + this.util.toCamelCase(this.__config.direction,true));
		this.util.removeStyleClass(contentElement,"nsVirtualScrollContent nsVirtualScrollContent" + this.util.toCamelCase(this.__config.direction,true));
		if(this.__scrollHandlerRef)
		{
			this.util.removeEvent(scrollElement,"scroll",this.__scrollHandlerRef);
			this.__scrollHandlerRef = null;
		}
		if(this.__resizeHandlerRef)
		{
			this.util.removeEvent(this.__win,"resize",this.__resizeHandlerRef);
			this.__resizeHandlerRef = null;
		}
		if(this.__internal.divLoader)
		{
			this.__internal.divLoader.parentNode.removeChild(this.__internal.divLoader);
		}
	};
	
	NSVirtualScroll.prototype.__initialize = function()
	{
		this.util = new NSUtil();
		if(this.__setting)
		{
			this.__config = {
					scrollElement: this.util.getElement(this.__setting["scrollElement"]),
					contentElement: this.util.getElement(this.__setting["contentElement"]),
					direction: this.__setting["direction"] || NSVirtualScroll.DIRECTION_VERTICAL,
					itemTag: this.__setting["itemTag"],
					pageSize: parseInt(this.__setting["pageSize"]) || 30,//number of items after the cache will be refreshed
					pagesRendered: parseInt(this.__setting["pagesRendered"]) || 3,//number of items(pageSize * pagesRendered) to be rendered
					items: this.__setting["items"],//array of items, can be html or nodes
					totalLength: parseInt(this.__setting["totalLength"]) || 0,//either mention items or totalLength and itemCreateCallback
					getItemComponent: this.__setting["getItemComponent"],
					getEmptyItemComponent: this.__setting["getEmptyItemComponent"],
					enableScrollDelay: Boolean.parse(this.__setting["enableScrollDelay"]),//for Mobile device which are slow in rendering
					scrollInterval: this.__setting["scrollInterval"],
					enableLoader: Boolean.parse(this.__setting["enableLoader"]),
					getLoaderComponent: this.__setting["getLoaderComponent"],
					resizeInterval: parseInt(this.__setting["resizeInterval"]) || 150,
					scrollingProgress: this.__setting["scrollingProgress"], //scrollingProgress callback while scrolling like  scrollingProgress(progress)
					pageWillChange: this.__setting["pageWillChange"], //pageWillChange callback before page change like  pageWillChange(oldPage,newPage)
					pageChanged: this.__setting["pageChanged"], //pageChanged callback before page change like  pageChanged(page)
				};
			if(!this.__config.scrollElement)
			{
				this.util.throwNSError("NSVirtualScroll","scrollElement is not valid");
			}
			if(!this.__config.contentElement)
			{
				this.util.throwNSError("NSVirtualScroll","contentElement is not valid");
			}
			this.__domVariables = this.util.getDomVariables();
			this.__doc = this.__domVariables.doc;
			this.__win = this.__domVariables.win;
			if((!this.__config.items || this.__config.items.length == 0) && !this.__config.totalLength)
			{
				this.__config.items = this.__fetchChildren(contentElement);
			}
			this.__setProps();
			this.__setInternalVars();
			this.__create();
			this.__addListeners();
		}
	};
	
	NSVirtualScroll.prototype.__setProps = function()
	{
		this.__objProp = {
			    vertical: {
			        direction:NSVirtualScroll.DIRECTION_VERTICAL,size: "height",offset: "offsetHeight",
			        scroll: "scrollTop", scrollSize: "scrollHeight",paddingStart:"paddingTop",
			        paddingEnd:"paddingBottom",marginStart:"marginTop",marginEnd:"marginBottom"
			    },
			    horizontal: {
			        direction:NSVirtualScroll.DIRECTION_HORIZONTAL,size: "width",offset: "offsetWidth",
			        scroll: "scrollLeft", scrollSize: "scrollWidth",paddingStart:"paddingLeft",
			        paddingEnd:"paddingRight",marginStart:"marginLeft",marginEnd:"marginRight"
			    }
		};
		this.__objSelectedProp = this.__objProp["vertical"];
		if(this.__config.direction == NSVirtualScroll.DIRECTION_HORIZONTAL)
		{
			this.__objSelectedProp = this.__objProp["horizontal"];
		}
	};
	
	//call this function only with init is needed
	NSVirtualScroll.prototype.__setInternalVars = function()
	{
		if(!this.__internal.itemDimension)
		{
			if(this.__config.contentElement.hasAttribute("tabindex"))
			{
				this.__internal.contentTabIndex = this.__config.contentElement.getAttribute("tabindex");
			}
			this.__internal.scrollIntervalID = -1;
			this.__internal.resizeIntervalID = -1;
			this.__internal.scrollPos = -1;
			this.__internal.lastPageNum = -1;
			this.__internal.objItemComp = {};
			this.__internal.objCache = {};
			this.__internal.cssExtraItem = "nsVirtualExtraItem" + this.util.toCamelCase(this.__objSelectedProp.direction,true);
			this.__internal.isMobile = this.util.isMobile().any;
			if(this.__config.enableScrollDelay && this.util.isUndefinedOrNull(this.__config.scrollInterval))
			{
				this.__config.scrollInterval = this.__internal.isMobile ? 300 : 0;
			}
			this.__internal.divLoader = null;
			this.__addLoader();
			this.__internal.pageSize = this.__config.pageSize;
			this.__internal.pagesRendered = this.__config.pagesRendered;
			var item = this.__getItemAt(0);
			if(item)
			{
				this.__internal.isItemHtml = this.util.isString(item);
				this.__setSize();
			}
			else
			{
				this.__internal.itemDimension = 0;
				this.__internal.pageDimension = 0;
				this.__internal.itemsRendered = 0;
				this.__internal.renderedSize = 0;
			}
		}
	};
	
	NSVirtualScroll.prototype.__setSize = function()
	{
		this.__internal.itemDimension = this.__getItemSize();
		this.__internal.pageDimension = this.__internal.itemDimension * this.__internal.pageSize;
		this.__internal.itemsRendered = this.__internal.pageSize * this.__internal.pagesRendered;
		this.__internal.renderedSize = this.__internal.pagesRendered * this.__internal.pageDimension;
	};
	
	NSVirtualScroll.prototype.__create = function()
	{
		var scrollElement = this.__config.scrollElement;
		var contentElement = this.__config.contentElement;
		this.util.addStyleClass(scrollElement,"nsVirtualScrollElement nsVirtualScrollElement" + this.util.toCamelCase(this.__config.direction,true));
		this.util.addStyleClass(contentElement,"nsVirtualScrollContent nsVirtualScrollContent" + this.util.toCamelCase(this.__config.direction,true));
		contentElement.setAttribute("tabindex",0);
		if((this.__config.items && this.__config.items.length) || this.__config.totalLength)
		{
			var scrollPos = scrollElement[this.__objSelectedProp.scroll];
			this.__addItems();
			scrollElement[this.__objSelectedProp.scroll] = scrollPos;
		}
	};
	
	NSVirtualScroll.prototype.__addListeners = function()
	{
		if(!this.__scrollHandlerRef)
		{
			this.__scrollHandlerRef = this.__config.enableScrollDelay ? this.__scrollHandlerWithDelay.bind(this) : this.__scrollHandler.bind(this);
			this.util.addEvent(this.__config.scrollElement,"scroll",this.__scrollHandlerRef);
		}
		if(!this.__resizeHandlerRef)
		{
			this.__resizeHandlerRef = this.__resizeHandler.bind(this);
			this.util.addEvent(this.__win,"resize",this.__resizeHandlerRef);
		}
	};
	
	NSVirtualScroll.prototype.__scrollHandlerWithDelay = function(event)
	{
		var self = this;
		clearTimeout(this.__internal.scrollIntervalID);
		this.__internal.scrollIntervalID = setTimeout(function(){
			self.__scrollHandler.call(self,event);
		},this.__config.scrollInterval);
	};
	
	NSVirtualScroll.prototype.__scrollHandler = function(event)
	{
		this.__internal.scrollIntervalID = -1;
		event = this.util.getEvent(event);
		var pageNumber = this.__getCurrentPageNum();
		var lastPageNum = this.__internal.lastPageNum;
		this.__internal.lastPageNum = pageNumber;
		/*console.log("lastPageNum::" + lastPageNum + " pageNumber::" + pageNumber);*/
		if(lastPageNum != pageNumber)
		{
			//console.log("In Scroll");
			this.__addItems();
			this.__fireCallback("scrollingProgress",this.getScrollProgress());
		}
	};
	
	//not used for now
	NSVirtualScroll.prototype.__isScrollingDown = function() {
		  var isScrollingDown = false;
		  var currentScrollPos = this.__config.scrollElement[this.__objSelectedProp.scroll];

		  if (currentScrollPos > this.__internal.prevScrollPos) {
		    isScrollingDown = true;
		  } else {
		    isScrollingDown = false;
		  }

		  this.__internal.prevScrollPos = currentScrollPos;
		  return isScrollingDown;
	};
	
	NSVirtualScroll.prototype.__resizeHandler = function(event)
	{
		event = this.util.getEvent(event);
		clearTimeout(this.__internal.resizeIntervalID);
		var self = this;
		this.__internal.resizeIntervalID = setTimeout(self.refresh.bind(self), this.__config.resizeInterval);
	};
	
	NSVirtualScroll.prototype.__getItemSize = function()
	{
		var contentElement = this.__config.contentElement;
		var isAdded = false;
		var size = null;
		if(!contentElement.children.length)
		{
            var itemHtml = this.__getItemAt(0);
			this.__setItemsInDom(itemHtml);
			isAdded = true;
		}
		var item = null;
		var length = contentElement.children.length;
		for(var count = 0;count < length;count++)
		{
			item = contentElement.children[count];
			if(!this.util.hasStyleClass(item,this.__internal.cssExtraItem))
			{
				break;
			}
		}
		if(!this.__config.itemTag)
		{
			this.__config.itemTag = item.tagName.toLowerCase();
		}
		size = item[this.__objSelectedProp.offset];
		if(this.__config.itemTag == "tr")
		{
			var border = this.util.getStyleValue(contentElement,"borderCollapse");
			if(border != "collapse")
			{
				var borderSpacing = this.util.getStyleValue(contentElement,"borderSpacing");
				size += this.__getInt(borderSpacing);
			}
		}
		else
		{
			var marginStart = this.util.getStyleValue(item,this.__objSelectedProp.marginStart);
	        var marginEnd = this.util.getStyleValue(item,this.__objSelectedProp.marginEnd);
	        marginStart = this.__getInt(marginStart);
	        marginEnd = this.__getInt(marginEnd);
	        size += Math.max(marginStart, marginEnd);
		}
		if(isAdded)
		{
			this.__setItemsInDom(null);
		}
		return size;
	};
	
	NSVirtualScroll.prototype.__addItems = function()
	{
		var arrItem = this.__internal.arrItem || [];
		var itemPage = this.__getPageData(arrItem,this.__getCurrentPageNum());
		var hasPageContentChanged = this.__hasCacheChanged("data",itemPage.arrItem);
        var hasStartOffsetChanged = this.__hasCacheChanged("top",itemPage.startOffset);
        var hasEndOffsetChanged = this.__hasCacheChanged("bottom",itemPage.endOffset);
        var contentElement = this.__config.contentElement;
        var arrSource = [];
        if(hasPageContentChanged || hasStartOffsetChanged) 
        {
            if(itemPage.startOffset) 
            {
            	arrSource.push(this.__getExtraItem("nsVirtualTopItem",itemPage.startOffset));
            }
            arrSource.push.apply(arrSource,itemPage.arrItem);
            if(itemPage.endOffset) 
            {
            	arrSource.push(this.__getExtraItem("nsVirtualBottomItem",itemPage.endOffset));
            }
            this.__fireCallback("pageWillChange",[this.__internal.currentItemPage,itemPage]);
            this.__setItemsInDom(arrSource);
            this.__handleTagAfterRender(itemPage);
            this.__fireCallback("pageChanged",[itemPage]);
            this.__internal.currentItemPage = itemPage;
        } 
        else if(hasEndOffsetChanged) 
        {
        	contentElement.lastChild.style[this.__objSelectedProp.size] = itemPage.endOffset + "px";
        }
	};
	
	NSVirtualScroll.prototype.__setItemsInDom = function(arrItem,isAdd)
	{
		this.__setLoaderVisibility(true);
		var contentElement = this.__config.contentElement;
		if(this.__internal.isItemHtml)
		{
			if(arrItem)
			{
				var html = this.__convertArrayToString(arrItem);
				isAdd ? contentElement.innerHTML += html : contentElement.innerHTML = html;
			}
			else
			{
				isAdd ? null : contentElement.innerHTML = "";
			}
		}
		else
		{
			if(!isAdd)
			{
				//IE Bug that when Html elements are added(i.e. when this.__internal.isItemHtml is false) you do contentElement.innerHTML = "" 
				//then the items being rendered in this.__internal.arrItem also becomes empty
				if(this.__internal.isItemHtml)
				{
					contentElement.innerHTML = "";
				}
				else
				{
					while(contentElement.firstChild) 
					{
						contentElement.removeChild(contentElement.lastChild);
					}
				}
			}
			if(arrItem)
			{
				arrItem = this.util.isArray(arrItem) ? arrItem : [arrItem];
				var item = null;
				var length = arrItem.length;
				for(var count =0;count < length;count++)
				{
					if(arrItem[count]) {
						item = arrItem[count];
						this.util.isString(item) ? contentElement.innerHTML += item : contentElement.appendChild(item);
					}
				}
			}
		}
		this.__setLoaderVisibility(false);
	};
	
	NSVirtualScroll.prototype.__getAllItems = function(fromIndex,toIndex)
	{
		if(this.__config.items && this.__config.items.length && this.__config.items.length > fromIndex)
		{
            toIndex = this.__config.items.length > toIndex ? toIndex : this.__config.items.length - 1;
            var arrCloned = this.__config.items.slice();
			var arrItem = arrCloned.splice(fromIndex,toIndex - fromIndex);
			return arrItem;
		}
		else if(this.__config.totalLength && this.__config.getItemComponent)
		{
            fromIndex = this.__config.totalLength > fromIndex ? fromIndex : this.__config.totalLength - 1;
            toIndex = this.__config.totalLength > toIndex ? toIndex : this.__config.totalLength - 1;
            if(!this.__internal.arrItem) {
				this.__internal.arrItem = [];
			}
			var arrItem = this.__internal.arrItem;
            var arrRet = [];
			for(var count = fromIndex;count < toIndex + 1;count++)
			{
                if(arrItem.length > count && arrItem[count]) {
                    arrRet.push(arrItem[count]);
                }
                else {
                    var item = this.__getItemFromComponent(count);
                    arrItem[count] = item;
                    arrRet.push(item);
                }
			}
			return arrRet;
		}
		return [];
	};

    NSVirtualScroll.prototype.__getItemAt = function(index) 
    {
        if(this.__config.items && this.__config.items.length && this.__config.items.length > index)
		{
           return this.__config.items[index];
		}
        else if(this.__config.arrItem && this.__config.arrItem.length && this.__config.arrItem.length > index && this.__config.arrItem[index])
		{
           return this.__config.arrItem[index];
		}
        else if(this.__config.totalLength > index && this.__config.getItemComponent) {
           return this.__getItemFromComponent(index);
        }
        return null;
    };
	
	NSVirtualScroll.prototype.__getItemFromComponent = function(index)
	{
		var item = null;
		if(this.__config.totalLength > index)
		{
			var comp = new this.__config.getItemComponent(index);
			item = comp.getElement();
			this.__internal.objItemComp[index.toString()] = comp;
		}
		return item;
	};
	
	NSVirtualScroll.prototype.__getPageData = function(arrItem,pageNum)
	{
		var internal = this.__internal;
		var retItem = null;
        if(this.__config.totalLength === 0)
		{
			retItem = {startOffset: 0,endOffset: 0,itemsBefore: 0,arrItem:[this.__getEmptyItem()]};
		}
		/*else if(arrItem.length < internal.pageSize)
		{
            var startIndex = 0;
	        var endIndex = internal.pageSize;
            var arrRet = this.__getAllItems(startIndex,endIndex);
			retItem = {startOffset: 0,endOffset: 0,itemsBefore: 0,arrItem:arrRet};
		}*/
		else
		{
			var startIndex = Math.max((internal.itemsRendered - internal.pageSize) * pageNum, 0);
	        var endIndex = startIndex + internal.itemsRendered;
            var totalLength = this.__getTotalLength();
	        var startOffset = Math.max(startIndex * internal.itemDimension, 0);
	        var endOffset = Math.max((totalLength - endIndex) * internal.itemDimension, 0);
	        var itemsBefore = startIndex;
	        if(startOffset < 1) 
	        {
	        	itemsBefore++;
	        }
	        var arrRet = this.__getAllItems(startIndex,endIndex);//arrItem.slice(startIndex,endIndex);
	        retItem = {startOffset: startOffset,endOffset: endOffset,itemsBefore: itemsBefore,arrItem:arrRet};
		}
		console.log(retItem);
		return retItem;
	};

    NSVirtualScroll.prototype.__getTotalLength = function() 
    {
        if(this.__config.items && this.__config.items.length)
		{
           return this.__config.items.length;
		}
        else if(this.__config.totalLength && this.__config.getItemComponent) {
           return this.__config.totalLength;
        }
        return 0;
    };
	
	NSVirtualScroll.prototype.__addNewItems = function(arrNewItem,isPrepend)
	{
		if(!this.util.isUndefinedOrNull(arrNewItem))
		{
			arrNewItem = this.util.isArray(arrNewItem) ? arrNewItem : [arrNewItem];
			if(arrNewItem && arrNewItem.length)
			{
				var arrItem = [];
				for(var count = 0;count < arrNewItem.length;count++)
				{
					arrItem.push(arrNewItem.items[count]);
				}
				var arrExisting = this.__internal.arrItem;
				this.__internal.arrItem = isPrepend ? arrItem.concat(arrExisting) : arrExisting.concat(arrItem);
				this.__addItems();
			}
		}
	};
	
	NSVirtualScroll.prototype.__handleTagAfterRender = function(itemPage)
	{
		var contentElement = this.__config.contentElement;
		if(this.__config.itemTag == "ol")
		{
			contentElement.setAttribute("start", itemPage.itemsBefore);
		}
	};
	
	NSVirtualScroll.prototype.__fetchChildren = function(element)
	{
		if(element)
		{
			var arrChildren = element.children;
			var arrRet = [];
			var length = arrChildren.length;
			var child = null;
			for(var count = 0;count < length;count++)
			{
				child = arrChildren[count];
				arrRet.push(this.__getItemHtml(child));
			}
			return arrRet;
		}
		return null;
	};
	
	NSVirtualScroll.prototype.__fireCallback = function(callbackName,args)
	{
		if(this.__config[callbackName]) {
			this.__config[callbackName](args);
		}
	};
	
	NSVirtualScroll.prototype.__hasCacheChanged = function(key,value)
	{
		var changed = (value != this.__internal.objCache[key]);
		this.__internal.objCache[key] = value;
	    return changed;
	};
	
	NSVirtualScroll.prototype.__getCurrentPageNum = function()
	{
		this.__internal.scrollPos = this.__config.scrollElement[this.__objSelectedProp.scroll];
		var pageNum = Math.floor(this.__internal.scrollPos / (this.__internal.renderedSize - this.__internal.pageDimension)) || 0;
		//console.log(this.__internal.scrollPos + "," + this.__internal.renderedSize + "," + this.__internal.pageDimension + "," + pageNum);
		return pageNum;
	};
	
	NSVirtualScroll.prototype.__getExtraItem = function(cssClass,size)
	{
		var item = this.util.createElement(this.__config.itemTag,null,this.__internal.cssExtraItem,this.__doc);
		cssClass && this.util.addStyleClass(item,cssClass);
		size && (item.style[this.__objSelectedProp.size] = size + "px");
		return (this.__internal.isItemHtml ? this.__getItemHtml(item) : item);
	};
	
	NSVirtualScroll.prototype.__getEmptyItem = function()
	{
		if(this.__config.getEmptyItemComponent)
		{
			var comp = new this.__config.getEmptyItemComponent();
			return (this.__internal.isItemHtml ? this.__getItemHtml(comp.getElement()) : comp.getElement());
		}
		var item = this.util.createElement(this.__config.itemTag,null,null,this.__doc);
		if(this.__config.itemTag == "tr")
		{
			item.innerHTML = "<td colSpan='1000'></td>";
		}
		return (this.__internal.isItemHtml ? this.__getItemHtml(item) : item);
	};
	
	NSVirtualScroll.prototype.__getItemHtml = function(item)
	{
		if(item)
		{
			return this.util.isString(item) ? item : item.outerHTML;
		}
		return "";
	};
	
	NSVirtualScroll.prototype.__addLoader = function()
	{
		if(this.__config.enableLoader)
		{
			this.__internal.divLoader = this.util.createDiv(null,"nsVirtualScrollLoader");
			var divText = null;
			if(this.__config.getLoaderComponent)
			{
				var comp = new this.__config.getLoaderComponent();
				divText = comp.getElement();
			}
			else
			{
				divText = this.util.createDiv(null,"nsVirtualScrollLoaderTextCon");
				divText.innerHTML = "<b class=\"nsVirtualScrollLoaderText\">Rendering...</b>";
			}
			this.__internal.divLoader.appendChild(divText);
			this.__setLoaderVisibility(false);
			this.__config.scrollElement.appendChild(this.__internal.divLoader);
		}
	};
	
	NSVirtualScroll.prototype.__setLoaderVisibility = function(isShow)
	{
		if(this.__internal.divLoader)
		{
			this.__internal.divLoader.style.display = isShow ? "" : "none";
		}
	};
	
	NSVirtualScroll.prototype.__convertArrayToString = function(arrItem,separator)
	{
		if(arrItem)
		{
			separator = separator ? separator : "";
			return this.util.isArray(arrItem) ? arrItem.join(separator) : arrItem;
		}
		return "";
	};
	
	NSVirtualScroll.prototype.__getInt = function(value)
	{
		return parseInt(value,10) || 0;
	};
	
	NSVirtualScroll.DIRECTION_VERTICAL = "vertical";
	NSVirtualScroll.DIRECTION_HORIZONTAL = "horizontal";
	
	return NSVirtualScroll;
})();
nsModuleExport(this,"NSVirtualScroll",NSVirtualScroll);
var NSList = (function()
{
	function NSList(component,setting) 
	{
		//this.base.call(this);
		this.ITEM_SELECTED = "itemSelected";
		this.ITEM_UNSELECTED = "itemUnselected";
		this.ITEM_NAVIGATED = "itemNavigated";
		this.NAVIGATION_UP = "up";
		this.NAVIGATION_DOWN = "down";
		this.ITEM_DROPPING = "itemDropping";
		this.ITEM_DROPPED = "itemDropped";
		this.DRAG_STARTED = "dragStarted";
		this.DRAGGING = "dragging";
		this.DRAG_END = "dragEnd";
		
		this.__setting = setting;
		this.__dataSource = null;
		this.__labelField = "label";
		this.__itemRenderer = null;
		this.__templateID = null;
		this.__setData = null;
		this.__labelFunction = null;
		this.__enableHierarchical = false;
		this.__enableMouseHover = false;
		this.__enableMouseHoverAnimation = false;
		this.__disableHoverField = null;
		this.__disableHoverFunction = null;
		this.__enableKeyboardNavigation = false;
		this.__enableMultipleSelection = false;
		this.__enableCustomScrollBar = false;
		this.__enableVirtualScroll = false;
		this.__isDraggable = true;
		this.__isDroppable = true;
		this.__enableDragByHandle = false;
		this.__dragHandlerClass = null;
		this.__enableDragAfterHold = false;
		this.__holdTime = 500;
		this.__enableCloneMode = false;
		this.__rowHeight = -1;
		this.__noDataMessage = "No matching records found";
		this.__enableContextMenu = false;
		this.__enableVariableRowHeight = false;
		this.__contextMenuProvider = null;
		this.__contextMenuSetting = null;
		this.__enableTruncateToFit = false;
		this.__toolTipField = null;
		this.__enableToolTipForTruncateText = false;
		this.__toolTipRenderer = null;
		
		this.__arrWrapper = null;
		this.__arrInternalSource = null;
		this.__arrFlatHierarchicalSource = [];
		
		this.__divOuterContainer = null;
		this.__divParentContainer = null;
		this.__listContainer = null;
		this.__scroller = null;
		this.__scrollerSetting = {};
		this.__customScrollBarSetting = {};
		this.__customScrollBarTooltip = null;
		
		this.__template = null;
		this.__currentIndex = -1;
		this.__selectedIndex = -1;
		this.__navigationIndex = -1;
		this.__selectedItem = null;
		this.__selectedItems = [];	
		this.__selectedIndexes = [];
		this.__lastNavigationDirection = null;
		this.__orignalItemKey = [];
		//for keyboard navigation
		this.__pageSize = 0;
		this.__scrollTarget = null;
		this.__startArrayElement = -1;
		this.__listItemHeight = 0;
		//for Virtual Scroll
		this.__virtualScrollSetting = {};
		this.__nsVirtualScroll = null; 
		this.__virtualRowHeight = 0;
		
		this.__childField = "children";
		this.__CLASS_GROUP_CELL = "nsListGroupCell";
		this.__CLASS_CELL_CHILD = "nsListCellChild";
		
		//removing this.getID() as prefix as move functionality from one list to another would have different fields.
		this.__fieldPrefix = "ns_field";
		this.__fieldIndex =  this.__fieldPrefix + "_item_index";
		this.__fieldVisibleIndex = this.__fieldPrefix + "_item_visible_index";
		this.__fieldItem = this.__fieldPrefix + "_item";
		this.__fieldDisableHover = this.__fieldPrefix + "_disableHover";
		this.__fieldSelected = this.__fieldPrefix + "_selected";
		this.__fieldHover = this.__fieldPrefix + "_hover";
		
		this.__fieldItemLevel = this.__fieldPrefix + "_item_level";
		this.__fieldItemVisible = this.__fieldPrefix + "_item_visible";
		this.__fieldParentIndex = this.__fieldPrefix + "_parent_index";
		this.__fieldHasChild = this.__fieldPrefix + "_item_hasChild";
		this.__fieldHasParent = this.__fieldPrefix + "_item_hasParent";
		this.__fieldIsCollapsed = this.__fieldPrefix + "_item_isCollapsed";
		this.__fieldItemArrow = this.__fieldPrefix + "_item_arrow";
		
		this.__isShiftPressed = false;
		this.__isCtrlPressed = false;
		
		this.__objGrid = null;
		this.__nsListFilter = null;
		this.__nsListDragDrop = null;
		this.__nsToolTipInElement = null;
		
		this.__keyDownRef = null;
		this.__keyUpRef = null;
		this.base.__setBaseComponent.call(this,component);
	};
	nsExtendPrototype(NSContainerBase,NSList);
	NSList.prototype.constructor = NSList;
	
	NSList.prototype.initializeComponent = function() 
	{
		this.base.initializeComponent.call(this);
		this.__setSetting();
		this.__initializePluggins();
	};
	
	NSList.prototype.setComponentProperties = function() 
	{
		this.base.setComponentProperties.call(this);
		this.__objGrid.__addSVGInPage();
		this.__setTemplate();
		this.__objGrid.__initialize();
		this.__addListenerForBody();
		if(this.__dataSource)
		{
			this.dataSource(this.__dataSource);
		}
		if(!window["nsListMap"])
		{
			window["nsListMap"] = {};
		}
		window["nsListMap"][this.getID()] = this;
	};
	
	NSList.prototype.propertyChange = function(attrName, oldVal, newVal, setProperty)
	{
		var attributeName = attrName.toLowerCase();
		this.base.propertyChange.call(this,attrName, oldVal, newVal, setProperty);
	};
	
	NSList.prototype.removeComponent = function() 
	{
		if(this.__keyDownRef)
		{
			this.util.removeEvent(document,"keydown",this.__keyDownRef);
			this.__keyDownRef = null;
		}
		if(this.__keyUpRef)
		{
			this.util.removeEvent(document,"keyup",this.__keyUpRef);
			this.__keyUpRef = null;
		}
		if(this.__scroller)
		{
			this.__scroller.__destroyElements();
			this.__scroller = null;
		}
		this.base.removeComponent.call(this);
	};
	
	NSList.prototype.componentResized = function(event) 
	{
		this.base.componentResized.call(this,event);
	};
	
	NSList.prototype.expandAll = function()
	{
		if(this.__enableHierarchical)
		{
			this.__expandCollapseAll(false);
		}
	};
	
	NSList.prototype.collapseAll = function()
	{
		if(this.__enableHierarchical)
		{
			this.__expandCollapseAll(true);
		}
	};
	
	NSList.prototype.setContextMenuSetting = function(contextMenuSetting)
	{
		this.__contextMenuSetting = contextMenuSetting;
	};
	
	NSList.prototype.__setSetting = function()
	{
		var setting = this.__setting;
		if(setting)
		{
			if(setting.hasOwnProperty("enableHierarchical"))
			{
				this.__enableHierarchical = Boolean.parse(setting["enableHierarchical"]);
			}
			if(setting.hasOwnProperty("enableVirtualScroll"))
			{
				this.__enableVirtualScroll = Boolean.parse(setting["enableVirtualScroll"]);
			}
			if(setting.hasOwnProperty("enableDragDrop"))
			{
				if(!this.__enableVirtualScroll)
				{
					this.__enableDragDrop = Boolean.parse(setting["enableDragDrop"]);
				}
			}
			if(setting.hasOwnProperty("isDraggable"))
			{
				this.__isDraggable = Boolean.parse(setting["isDraggable"]);
			}
			if(setting.hasOwnProperty("isDroppable"))
			{
				this.__isDroppable = Boolean.parse(setting["isDroppable"]);
			}
			if(setting.hasOwnProperty("enableDragByHandle"))
			{
				this.__enableDragByHandle = Boolean.parse(setting["enableDragByHandle"]);
			}
			if(setting.hasOwnProperty("dragHandlerClass"))
			{
				this.__dragHandlerClass = setting["dragHandlerClass"];
			}
			if(setting.hasOwnProperty("enableDragAfterHold"))
			{
				this.__enableDragAfterHold = Boolean.parse(setting["enableDragAfterHold"]);
			}
			if(setting.hasOwnProperty("holdTime"))
			{
				this.__holdTime = parseInt(setting["holdTime"]);
			}
			if(setting.hasOwnProperty("enableCloneMode"))
			{
				this.__enableCloneMode = Boolean.parse(setting["enableCloneMode"]);
			}
			if(setting.hasOwnProperty("labelField"))
			{
				this.__labelField = setting["labelField"];
			}
			if(setting.hasOwnProperty("itemRenderer"))
			{
				this.__itemRenderer = setting["itemRenderer"];
				this.__itemRenderer = this.util.getFunction(this.__itemRenderer);
			}
			if(setting.hasOwnProperty("template"))
			{
				this.__templateID = setting["template"];
			}
			if(setting.hasOwnProperty("setData"))
			{
				this.__setData = setting["setData"];
			}
			if(setting.hasOwnProperty("labelFunction"))
			{
				this.__labelFunction = setting["labelFunction"];
				this.__labelFunction = this.util.getFunction(this.__labelFunction);
			}
			if(setting.hasOwnProperty("enableMultipleSelection"))
			{
				this.__enableMultipleSelection =  Boolean.parse(setting["enableMultipleSelection"]);
			}
			if(setting.hasOwnProperty("enableCustomScrollBar"))
			{
				this.__enableCustomScrollBar =  Boolean.parse(setting["enableCustomScrollBar"]);
			}
			if(setting.hasOwnProperty("enableKeyboardNavigation"))
			{
				this.__enableKeyboardNavigation =  Boolean.parse(setting["enableKeyboardNavigation"]);
			}
			if(setting.hasOwnProperty("enableMouseHover"))
			{
				this.__enableMouseHover =  Boolean.parse(setting["enableMouseHover"]);
			}
			if(setting.hasOwnProperty("enableMouseHoverAnimation"))
			{
				this.__enableMouseHoverAnimation =  Boolean.parse(setting["enableMouseHoverAnimation"]);
			}
			if(setting.hasOwnProperty("disableHoverField"))
			{
				this.__disableHoverField = setting["disableHoverField"];
			}
			if(setting.hasOwnProperty("disableHoverFunction"))
			{
				this.__disableHoverFunction = setting["disableHoverFunction"];
				this.__disableHoverFunction = this.util.getFunction(this.__disableHoverFunction);
			}
			if(setting.hasOwnProperty("rowHeight"))
			{
				this.__rowHeight =  parseInt(setting["rowHeight"]);
			}
			if(setting.hasOwnProperty("noDataMessage"))
			{
				this.__noDataMessage = setting["noDataMessage"];
			}
			if(setting.hasOwnProperty("dataSource"))
			{
				this.__dataSource = setting["dataSource"];
			}
			if(setting.hasOwnProperty("childField"))
			{
				this.__childField = setting["childField"];
			}
			if(setting.hasOwnProperty("enableContextMenu"))
			{
				this.__enableContextMenu = Boolean.parse(setting["enableContextMenu"]);
			}
			if(setting.hasOwnProperty("contextMenuProvider"))
			{
				this.__contextMenuProvider =  setting["contextMenuProvider"];
				this.__contextMenuProvider = this.util.getFunction(this.__contextMenuProvider);
			}
			if(setting.hasOwnProperty("enableVariableRowHeight"))
			{
				this.__enableVariableRowHeight =  Boolean.parse(setting["enableVariableRowHeight"]);
			}
			if(setting.hasOwnProperty("customScrollBarSetting"))
			{
				this.__customScrollBarSetting =  setting["customScrollBarSetting"];
			}
			else
			{
				this.__customScrollBarSetting = {enableTooltip: false,toolTipLabelFunction: null,verticalScrollButtons: {enable: false},horizontalScrollButtons:{enable: false}};
			}
			if(setting.hasOwnProperty("virtualScrollSetting"))
			{
				this.__virtualScrollSetting = setting["virtualScrollSetting"];
			}
			else
			{
				this.__virtualScrollSetting = {pageSize: null,pagesRendered: null,enableScrollDelay: false,scrollInterval: null,resizeInterval: null,enableLoader: false,getLoaderComponent: null};
			}
		}
	};
	
	NSList.prototype.dataSource = function(source)
	{
		this.__dataSource = source;
		if(this.__listContainer)
		{
			this.util.removeAllChildren(this.__listContainer);
		}
		else
		{
			this.__createStructure();
		}
		if(this.__dataSource && this.__dataSource.length > 0)
		{
			this.__orignalItemKey = Object.keys(this.__dataSource[0]);
			this.__objGrid.dataSource();
		}
		else
		{
			this.__arrWrapper = [];
			this.__arrInternalSource = [];
			this.__updateTotalRecords(0);
		}
		this.__renderBody();
	};
	
	NSList.prototype.getOrignalItem = function(item)
	{
		if(item && this.__orignalItemKey && this.__orignalItemKey.length > 0)
		{
			var retItem = {};
			var key = null;
			for(var count = 0;count < this.__orignalItemKey.length;count++)
			{
				key = this.__orignalItemKey[count];
				retItem[key] = item[key];
			}
			return retItem;
		}
		return item;
	};
	
	NSList.prototype.addItems = function(arrItem)
	{
		this.__addItem(arrItem);
	};
	
	NSList.prototype.addItemsAsChildren = function(item,arrChildren)
	{
		this.__objGrid.addItemsAsChildren(item,arrChildren);
	};
	
	NSList.prototype.removeItems = function(arrObject)
	{
		if(arrObject && arrObject.length > 0)
		{
			var arrIndex = [];
			if(this.util.isNumber(arrObject[0]))
			{
				arrIndex = arrObject;
			}
			else
			{
				for (var count = 0;count < arrObject.length;count++)
			    {
					var item = arrObject[count];
					if(item && item[this.__fieldIndex])
					{
						arrIndex.push(item[this.__fieldIndex]);
					}
			    }
			}
			arrIndex.sort();
	   	 	for (var rowIndex = arrIndex.length - 1; rowIndex >= 0; rowIndex--)
		    {
	   	 		var index = arrIndex[rowIndex];
	   	 		if(index > 0 && index < this.__arrInternalSource.length)
	   	 		{
		   	 		//if virtual scroll or Pagination of type Page is enabled then do not remove rows
		   	 		if(!this.__enableVirtualScroll)
		   	 		{
		   	 			this.__listContainer.removeChild(this.__listContainer.childNodes[index]);
		   	 		}
		   	 		this.__arrInternalSource.splice(index, 1);
		   	 		this.__arrWrapper.splice(index, 1);
	   	 		}
		    }
		 	this.__updateTotalRecords();
		}
	};
	
	NSList.prototype.scrollToIndex = function(selectedIndex,animationRequired)
	{
		selectedIndex = parseInt(selectedIndex);
		var source = this.__objGrid.__getFlatSource();
		if(selectedIndex > -1 && source && selectedIndex < source.length)
		{
			var item = this.__getItemByIndex(selectedIndex);
			if(item)
			{
				if(this.__enableVirtualScroll)
				{
					if(this.__enableCustomScrollBar)
					{
						var targetDimension = this.__virtualRowHeight * (selectedIndex - 1);
						this.__setVirtualScroll_ScrollTop(targetDimension);
					}
					else
					{
						//var item = this.__getVisibleItemByIndex(this.__arrInternalSource,selectedIndex);
						if(this.__nsVirtualScroll)
						{
							//because in list index is index+1
							this.__nsVirtualScroll.scrollToIndex(selectedIndex - 1,animationRequired);
						}
					}
				}
				else
				{
					if(item[this.__fieldItem])
					{
						var targetDimension = item[this.__fieldItem].offsetTop;
						var scrollTarget = this.__divOuterContainer;
						if(animationRequired)
						{
							var animation = new this.util.animation(scrollTarget,[
				       	  	    {
				       	  	      time: 500,
				       	  	      property:"scrollTop",
				       	  	      target: targetDimension,
				       	  	    }
				       	  	]);
				   	  	  	animation.animate();
						}
						else
						{
							scrollTarget.scrollTop = targetDimension;
						}
					}
				}
			}
		}
	};
	
	NSList.prototype.setSelectedItems = function(arrItems)
	{
		if(arrItems && arrItems.length > 0)
		{
			var source = this.__objGrid.__getFlatSource();
			if(source)
			{
				this.__clearAllRowSelection(false);
				var length = arrItems.length;
				var item = null;
				var index = -1;
				for(var count = 0;count < length;count++)
				{
					item = arrItems[count];
					index = this.__getIndexByItem(item);
					if(index > -1 && source && index < source.length)
					{
						this.__setIndex(index,true);
					}
				}
			}
		}
	};
	
	NSList.prototype.setSelectedItem = function(arrItems)
	{
		this.setSelectedItems([arrItems]);
	};
	
	NSList.prototype.setSelectedIndexes = function(arrSelectedIndex)
	{
		if(arrSelectedIndex && arrSelectedIndex.length > 0)
		{
			var source = this.__objGrid.__getFlatSource();
			if(source)
			{
				var length = arrSelectedIndex.length;
				var index = -1;
				for(var count = 0;count < length;count++)
				{
					index = arrSelectedIndex[count];
					if(index > -1 && source && index < source.length)
					{
						this.__setIndex(index,true);
					}
				}
			}
		}
	};
	
	NSList.prototype.setSelectedIndex = function(selectedIndex)
	{
		this.setSelectedIndexes([selectedIndex]);
	};
	
	NSList.prototype.unSelectItems = function(arrItems)
	{
		
	};
	
	NSList.prototype.unSelectItem = function(arrItems)
	{
		this.unSelectItems([arrItems]);
	};
	
	NSList.prototype.unSelectIndexes = function(arrSelectedIndex)
	{
		
	};
	
	NSList.prototype.unSelectIndex = function(selectedIndex)
	{
		this.unSelectIndexes([selectedIndex]);
	};
	
	NSList.prototype.getSelectedIndex = function()
	{
		return this.__selectedIndex;
	};
	
	NSList.prototype.getSelectedItem = function()
	{
		return this.__selectedItem;
	};
	
	NSList.prototype.getSelectedIndexes = function()
	{
		return this.__selectedIndexes;
	};
	
	NSList.prototype.getSelectedItems = function()
	{
		return this.__selectedItems;
	};
	
	NSList.prototype.deselectAll = function()
	{
		this.__clearAllRowSelection(true);
	};
	
	NSList.prototype.filter = function(strData,setting,enableHighlighting,recordLimit)
	{
		this.__nsListFilter.filter(strData,setting,enableHighlighting,recordLimit);
	};
	
	NSList.prototype.resetFilter = function()
	{
		this.__nsListFilter.reset();
	};
	
	NSList.prototype.updateListItemByIndex = function(index)
	{
		var item = this.__getItemByIndex(index);
		if(item)
		{
			var listItem = this.__getListItemFromItem(item);
			if(listItem)
			{
				var index = this.__getIndexByItem(item);
				this.__updateListItemText(listItem,item,index);
			}
		}
	};
	
	NSList.prototype.__highlightDiv = function(divText)
	{
		this.__nsListFilter.__highlightDiv(divText);
	};
	
	NSList.prototype.__initializePluggins = function()
	{
		if(!this.__objGrid)
		{
			if(this.__enableHierarchical)
			{
				this.__objGrid = new NSHierarchicalList(this);
			}
			else
			{
				this.__objGrid = new NSFlatList(this);
			}
		}
		if(!this.__nsListFilter)
		{
			this.__nsListFilter = new NSListFilter(this);
			if(this.__enableDragDrop)
			{
				this.__nsListDragDrop = new NSListDragDrop(this);
			}
		}
		this.__nsToolTipInElement = new this.util.nsToolTipInElement();
	};
	
	NSList.prototype.__createStructure = function()
	{
		if(!this.__divOuterContainer)
		{
			this.__divOuterContainer = this.util.createDiv(this.getID() + "container","nsListOuterContainer");
			if(this.__enableHierarchical)
			{
				this.util.addStyleClass(this.__divOuterContainer,"nsListOuterContainerHierarchical")
			}
			this.__divOuterContainer.style.width = this.util.getStyleValue(this.__baseComponent,"width");
			//this.__divOuterContainer.style.height = this.util.getStyleValue(this.__baseComponent,"height");
			this.addChild(this.__divOuterContainer);
			this.__divParentContainer = this.util.createDiv(this.getID() + "parentContainer","nsListParentContainer");
			this.__divOuterContainer.appendChild(this.__divParentContainer);
			this.__listContainer = this.util.createElement("ul",this.getID() + "list","nsListContainer");
			this.__listContainer.style.minHeight = (this.__divOuterContainer.clientHeight - 10) + "px";
			this.__divParentContainer.appendChild(this.__listContainer);
			if(this.__enableVirtualScroll)
			{
				this.util.addStyleClass(this.__divParentContainer,"nsListBodyContainerVirtual");
			}
			this.__createCustomScroller();
		}
	};

	NSList.prototype.__renderBody = function()
	{
		this.__navigationIndex = -1;
		if(this.__enableContextMenu)
		{
			this.__initializeContextMenu();
		}
		if(this.__enableVirtualScroll)
		{
			this.__setNSVirtualScroll(this.__arrInternalSource);
		}
		else
		{
			this.util.removeAllChildren(this.__listContainer);
			this.__createList(this.__arrInternalSource,0,this.__arrInternalSource.length);
			//5 is offset for number of rows
			var listItem = this.__getListItemByIndex(0);
			if(listItem)
			{
				this.__listItemHeight = listItem.clientHeight;
			}
			this.__pageSize = (this.__divOuterContainer.clientHeight/this.__listItemHeight) - 5;
			this.__startArrayElement = 0;
		}
		//this.__listContainer.scrollTop = 0;
		if(this.__nsListDragDrop)
		{
			this.__nsListDragDrop.initialize();
		}
	};
	
	NSList.prototype.__setNSVirtualScroll = function(source)
	{
		var length = 0;
		if(source && source.length)
		{
			for(var count = 0;count < source.length;count++)
			{
				if(source[count][this.__fieldItemVisible])
				{
					length++;
				}
			}
		}
		if(this.__nsVirtualScroll)
		{
			this.__nsVirtualScroll.dataSource(length);
		}
		else
		{
			if(length > 0)
			{
				if(this.__rowHeight > 0)
				{
					this.__virtualRowHeight = this.__rowHeight;
				}
				else
				{
					this.__createList(this.__arrInternalSource,0,1);
					var item = this.__arrInternalSource[0];
					var listItem = item[this.__fieldItem];
				    this.__virtualRowHeight = listItem.offsetHeight;
				    listItem.parentNode.removeChild(listItem);
				}
				var setting = {scrollElement: this.__divOuterContainer,contentElement: this.__listContainer,itemTag: "li",totalLength: length,getItemComponent:this.__getItemComponentForVirtual.call(this),getEmptyItemComponent:this.__getEmptyItemComponentForVirtual.call(this)};
				var virtualScrollSetting = this.__virtualScrollSetting;
				var arrCopyFields = ["pageSize","pagesRendered","enableScrollDelay","scrollInterval","resizeInterval","enableLoader","getLoaderComponent"];
				var field = null;
				for(var count = 0;count < arrCopyFields.length;count++)
				{
					field = arrCopyFields[count];
					if(!this.util.isUndefinedOrNull(virtualScrollSetting[field]))
					{
						setting[field] = virtualScrollSetting[field];
					}
				}
				this.__nsVirtualScroll = new NSVirtualScroll(setting);
			}
		}
	};
	
	NSList.prototype.__getItemComponentForVirtual = function()
	{
		var list = this;
		var CreateListItem = function(index)
		{
			this.__index = index;
			this.__list =  list;
			this.__item = null;
			this.__listItem = null;
		};
		CreateListItem.prototype.getElement = function()
		{
			if(!this.__listItem)
			{
				if(this.__list.__enableHierarchical)
				{
					this.__item = this.__list.__getVisibleItemByIndex(null,this.__index);
				}
				else
				{
					this.__item = this.__list.__arrInternalSource[this.__index];
				}
				this.__listItem = this.__list.__createListItem(this.__item,false);
			}
			return this.__listItem;
		};
		return CreateListItem;
	};
	
	NSList.prototype.__getEmptyItemComponentForVirtual = function()
	{
		var list = this;
		var CreateEmptyListItem = function()
		{
			this.__list =  list;
			this.__listItem = null;
		};
		CreateEmptyListItem.prototype.getElement = function()
		{
			if(!this.__listItem)
			{
				this.__listItem = this.__list.__createNoDataRow.call(this.__list);
			}
			return this.__listItem;
		};
		return CreateEmptyListItem;
	};
	
	NSList.prototype.__createCustomScroller = function()
	{
		if(this.__enableCustomScrollBar && !this.__scroller)
		{
			var setting = {element: this.__divOuterContainer,enableCustomHandler: true,verticalScrollButtons:this.__customScrollBarSetting.verticalScrollButtons,horizontalScrollButtons:this.__customScrollBarSetting.horizontalScrollButtons};
			for (var key in setting) 
			{ 
				this.__scrollerSetting[key] = setting[key]; 
			}
			this.__scroller = new NSScroller(this.__scrollerSetting);
			this.util.addEvent(this.__scrollerSetting.element,NSScroller.SCROLLING,this.__customScrollHandler.bind(this));
			this.util.addEvent(this.__scrollerSetting.element,NSScroller.SCROLL_END,this.__customScrollEndHandler.bind(this));
		}
	};
	
	NSList.prototype.__customScrollHandler = function(event)
	{
		var self = this;
		var virtualVerHandler = function()
		{
			//todo Virtual Scroll impl for Custom Scroll Bar
		};
		var dataRefreshVerHandler = function()
		{
			
		};
		var asyncLoadVerHandler = function()
		{
			
		};
		var paginationVerHandler = function()
		{
			
		};
		var normalVerHandler = function()
		{
			self.__divOuterContainer.scrollTop = scrollPos;
			
			var first,last;
			var arrRows = self.__listContainer.querySelectorAll("li");
			for(var count = 0;count < arrRows.length;count++)
			{
				var li = arrRows[count];
				if(isInViewport(li))
				{
					first = li;
					break;
				}
			}
			for(;count < arrRows.length;count++)
			{
				var li = arrRows[count];
				if(!isInViewport(li))
				{
					break;
				}
				last = li;
			}
			console.log(first,last);
		};
		var normalHorHandler = function()
		{
			self.__divOuterContainer.scrollLeft = scrollPos;
		};
		var isInViewport = function (elem) 
		{
			if(elem)
			{
				/*var distance = elem.getBoundingClientRect();
				return (
					distance.top >= 0 &&
					distance.left >= 0 &&
					distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
					distance.right <= (window.innerWidth || document.documentElement.clientWidth)
				);*/
				const rect = elem.getBoundingClientRect();
			    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
			    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

			    const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
			    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

			    return (vertInView && horInView);
			}
			return false;
		};
		var objCondition = {virtualScroll:{eligible:this.__enableVirtualScroll,verHandler:virtualVerHandler,horHandler:normalHorHandler},
							dataRefreshOnEnd:{eligible:this.__enableDataRefreshOnScrollEnd,verHandler:dataRefreshVerHandler,horHandler:normalHorHandler},
							asyncLoad:{eligible:this.__enableAsyncLoadPagination,verHandler:asyncLoadVerHandler,horHandler:normalHorHandler},
							pagination:{eligible:(this.__enablePagination && this.__isPaginationTypeScroll),verHandler:paginationVerHandler,horHandler:normalHorHandler},
							normal:{eligible:true,verHandler:normalVerHandler,horHandler:normalHorHandler}
						   };
		var eventItem = event;
		var direction = eventItem.direction;
		var scrollPos = eventItem.scrollPos;
		var oldScrollPos = eventItem.oldScrollPos;
		var orignalEvent = eventItem.orignalEvent;
		var scrollBar = eventItem.scrollBar;
		var position = eventItem.absoluteScrollBarPos;
		for(var key in objCondition)
		{
			var item = objCondition[key];
			if(item.eligible)
			{
				if(direction == "vertical")
				{
					if(item.verHandler)
					{
						if(this.__customScrollBarSetting["enableTooltip"] && !this.__customScrollBarTooltip)
						{
							this.__customScrollBarTooltip = this.util.createElement("span",null,"tooltiptext tooltip-left");
							document.body.appendChild(this.__customScrollBarTooltip);
						}
						item.verHandler();
					}
				}
				else
				{
					if(item.horHandler)
					{
						item.horHandler();
					}
				}
				break;
			}
		}
	};
	
	NSList.prototype.__customScrollEndHandler = function(event)
	{
		if(this.__customScrollBarTooltip)
		{
			document.body.removeChild(this.__customScrollBarTooltip);
			this.__customScrollBarTooltip = null;
		}
	};
	
	NSList.prototype.__customScrollTooltipPos = function(scrollbar,position,itemFrom,itemTo)
	{
		if(this.__customScrollBarTooltip)
		{
			var toolTip = this.__customScrollBarTooltip;
			var css = {};
			//5 for the triangle
			css.left = (position.x - toolTip.offsetWidth - 5) + "px";
			css.top = position.y + "px";
			this.util.css(toolTip,css);
			if(this.__customScrollBarSetting.toolTipLabelFunction)
			{
				toolTip.innerHTML = this.__customScrollBarSetting.toolTipLabelFunction(itemFrom,itemTo);
			}
			else
			{
				toolTip.innerHTML = "Showing Record from index " + itemFrom + " to " +  itemTo;
			}
		}
		
	};
	
	NSList.prototype.__virtualRowSelection = function()
	{
		if(this.__listContainer.children && this.__listContainer.children.length > 0 && this.__arrInternalSource)
		{
			var listItem = null;
			var index = null;
			var item = null;
			for(var count = 0; count < this.__listContainer.children.length; count++) 
			{
				listItem = this.__listContainer.children[count];
				index = this.__getIndexFromTarget(listItem);
				item = this.__getItemByIndex(index);
				if(item && this.__isMouseHoverAllowed(index))
				{
					if(item[this.__fieldSelected])
					{
						//DONOT REPLACE WITH __markRowSelected
						this.util.addStyleClass(listItem,"nsListItemSelected"); 
					}
					else
					{
						//DONOT REPLACE WITH __markRowUnselected
						this.util.removeStyleClass(listItem,"nsListItemSelected");
					}
				}
			}
		}
	};
	
	NSList.prototype.__virtualRowHover = function()
	{
		if(this.__listContainer.children && this.__listContainer.children.length > 0 && this.__arrInternalSource)
		{
			var listItem = null;
			var index = null;
			var item = null;
			for(var count = 0; count < this.__listContainer.children.length; count++) 
			{
				listItem = this.__listContainer.children[count];
				index = this.__getIndexFromTarget(listItem);
				item = this.__getItemByIndex(index);
				(item && item[this.__fieldHover]) ? this.util.addStyleClass(listItem,"nsListItemHover") : this.util.removeStyleClass(listItem,"nsListItemHover");
			}
		}
	};
	
	NSList.prototype.__setVirtualRowHoverField = function(indexToSet)
	{
		if(this.util.isUndefinedOrNull(indexToSet))
		{
			indexToSet = -1;
		}
		var source = this.__objGrid.__getFlatSource();
		if(source)
		{
			var item = null;
			for(var count = 0; count < source.length; count++) 
			{
				var item = source[count];
				if(item)
				{
					item[this.__fieldHover] = (item[this.__fieldIndex] === indexToSet); 
				}
			}
		}
	};
	
	NSList.prototype.__setVirtualRowHover = function(indexToSet)
	{
		if(this.__enableVirtualScroll)
		{
			if(this.util.isUndefinedOrNull(indexToSet))
			{
				indexToSet = 0;
			}
			var item = this.__getVisibleItemByIndex(null,indexToSet);
			if(item)
			{
				this.__navigationIndex = indexToSet;
				var index = item[this.__fieldIndex];
				this.__setVirtualRowHoverField(index);
				this.__virtualRowHover();
			}
			
		}
	};
	
	NSList.prototype.__setRowHover = function(indexToSet)
	{
		if(this.util.isUndefinedOrNull(indexToSet))
		{
			indexToSet = 0;
		}
		if(this.__enableVirtualScroll)
		{
			this.__setVirtualRowHover(indexToSet);
		}
		else
		{
			if(this.util.isUndefinedOrNull(indexToSet))
			{
				indexToSet = 0;
			}
			this.__navigationIndex = indexToSet;
			var listItem = this.__getListItemFromContainer(this.__navigationIndex);
			this.util.addStyleClass(listItem,"nsListItemHover");
		}
	};
	
	NSList.prototype.__createNoDataRow = function()
	{
		var listItem = this.util.createElement("li",null,"nsListNoRecordsFound");
		listItem.setAttribute("nsNoData","true");
		var textNode = document.createTextNode(this.__noDataMessage);
		listItem.appendChild(textNode);
		return listItem;
	};
	
	NSList.prototype.__addListenerForBody = function()
	{
		if(!this.__keyDownRef)
		{
			this.__keyDownRef = this.__keyDownHandler.bind(this);
			this.util.addEvent(document,"keydown",this.__keyDownRef);
		}
		if(!this.__keyUpRef)
		{
			this.__keyUpRef = this.__keyUpHandler.bind(this);
			this.util.addEvent(document,"keyup",this.__keyUpRef);
		}
	};
	
	NSList.prototype.__createList = function(dataSet,startIndex,endIndex)
	{
		if(dataSet && dataSet.length > 0)
	    {
			this.__objGrid.__createList(dataSet,startIndex,endIndex);
	    }
		else
		{
			this.__listContainer.appendChild(this.__createNoDataRow());
		}
	};
	
	NSList.prototype.__createListAt = function(item,index,isResetIndex)
	{
		if(item && index > -1)
	    {
			this.__updateItem(item,index,true,isResetIndex);
			var listItem = this.__createListItem(item,false);
			this.__listContainer.insertBefore(listItem, this.__listContainer.childNodes[index]);
			return listItem;
	    }
		return null;
	};
	
	NSList.prototype.__updateItem = function(item,index,isReset,isResetIndex)
	{
		if(item)
		{
			if(isResetIndex || !item.hasOwnProperty(this.__fieldIndex))
			{
				item[this.__fieldIndex] = index;
			}
			if(isReset || !item.hasOwnProperty(this.__fieldDisableHover))
			{
				item[this.__fieldDisableHover] = this.__isHoverDisabled(item);
			}
			if(isReset || !item.hasOwnProperty(this.__fieldSelected))
			{
				item[this.__fieldSelected] = false;
			}
		}
	};
	
	NSList.prototype.__createListItem = function(item,isAdd)
	{
		if(item)
		{
			 if(this.util.isUndefined(isAdd) || isAdd === null)
			 {
				 isAdd = true;
			 }
			 var listItem = this.util.createElement("li",null,"nsListItem");
			 this.__objGrid.__createListItem(listItem,item);
			 if(this.__enableMouseHover)
			 {
				 this.util.addEvent(listItem,"mouseover",this.__itemMouseOverHandler.bind(this));
				 this.util.addEvent(listItem,"mouseout",this.__itemMouseOutHandler.bind(this));
				 if(this.__enableMouseHoverAnimation)
				 {
					 this.util.addStyleClass(listItem,"nsListItemAnimated");
				 }
				 else
				 {
					 this.util.addStyleClass(listItem,"nsListItemNormal");
				 }
			 }
			 this.util.addEvent(listItem,"click",this.__itemClickHandler.bind(this));
			 this.__setListItemProperties(listItem,item);
			 if(isAdd)
			 {
				 this.__listContainer.appendChild(listItem);
			 }
			 return listItem;
		}
		return null;
	};
	
	NSList.prototype.__setListItemProperties = function(listItem,item)
	{
		this.__objGrid.__setListItemProperties(listItem,item);
	};
	
	NSList.prototype.__addCellText = function(listItem,item,div)
	{
		var toolTipText = null;
		if(listItem && item && div)
		{
			if(this.__itemRenderer)
			{
				var objRenderer = this.__itemRenderer(item,this.__labelField,item[this.__fieldIndex],item[this.__fieldDisableHover],listItem);
				if(objRenderer)
				{
					if(this.util.isString(objRenderer))
					{
						var compBodySpan = document.createElement("span");
						compBodySpan.innerHTML = objRenderer;
						div.appendChild(compBodySpan);
					}
					else
					{
						div.appendChild(objRenderer);
					}
				}
			}
			else if(this.__template)
			{
				div.appendChild(this.__template.cloneNode(true));
				this.__setDataInTemplateRenderer(div,item,listItem);
			}
			else if(this.__labelFunction)
			{
				var text = this.__labelFunction(item,this.__labelField);
				div.appendChild(document.createTextNode(text));
			}
			else if(item.hasOwnProperty(this.__labelField) && !this.util.isUndefined(item[this.__labelField]) && item[this.__labelField] != null)
		    {
				var text = item[this.__labelField];
				div.appendChild(document.createTextNode(text));
		    }
			this.__highlightDiv(div);
			if(this.__toolTipField)
			{
				toolTipText = item[this.__toolTipField];
			}
			else if(this.__toolTipRenderer)
			{
				toolTipText = this.__toolTipRenderer(item,this.__labelField,item[this.__fieldIndex],item[this.__fieldDisableHover],listItem);
			}
			if(this.__enableTruncateToFit)
			{
				this.util.addStyleClass(div,"nsListTruncateToFit");
				//This condition is above so that toolTip and title are not set togeather
				if(!toolTipText || toolTipText === "")
				{
					if(this.__enableToolTipForTruncateText)
					{
						toolTipText = div.textContent;
					}
					else
					{
						div.setAttribute("title",div.textContent);
					}
				}
			}
			if(toolTipText && toolTipText !== "")
			{
				this.__nsToolTipInElement.addToolTip(div,toolTipText);
			}
		}
	};
	
	NSList.prototype.__setDataInTemplateRenderer = function(cellItem,data,listItem)
	{
		if(cellItem && this.__setData)
		{
			this.__setRendererProperties(cellItem);
			this.__setRendererInData(cellItem,data,listItem);
			//IE bug
			cellItem.data = data;
			if(this.util.isFunction(this.__setData))
		    {
				var strParam = "(cellItem,data,dataField,isDisabled,listItem)"; 
		    	if(this.util.isString(this.__setData))
		    	{
		    		var base = this;
		    		this.util.callFunctionFromString(this.__setData + strParam,function(paramValue){
						if(paramValue === "cellItem")
						{
							return cellItem;
						}
						if(paramValue === "data")
						{
							return data;
						}
						if(paramValue === "dataField")
						{
							return base.__labelField;
						}
						if(paramValue === "isDisabled")
						{
							return data[base.__fieldDisableHover];
						}
						if(paramValue === "listItem")
						{
							return listItem;
						}
						return paramValue;
					});
		    	}
		    	else
		    	{
		    		this.__setData(cellItem,data,this.__labelField,data[this.__fieldDisableHover],listItem);
		    	}
		    }
		}
	};
	
	NSList.prototype.__setRendererInData = function(cellItem,data,listItem)
	{
		if(cellItem)
		{
			var compChild = null;
			for(var count = 0; count < cellItem.children.length; count++) 
			{
				compChild = cellItem.children[count];
				if(compChild)
				{
					compChild.data = data;
					compChild.listItem = listItem;
				}
				//IE 9 Bug,you got to assign it back
				//listItem.children[count] = compChild;
				this.__setRendererInData(compChild,data,listItem);
			}
		}
	};
	
	NSList.prototype.__setRendererProperties = function(cellItem)
	{
		if(cellItem)
		{
			var compChild = null;
			for(var count = 0; count < cellItem.children.length; count++) 
			{
				compChild = cellItem.children[count];
				var grid = this;
				Array.prototype.slice.call(compChild.attributes).forEach(function(attribute) 
				{
			        if(grid.util.isFunction(attribute.value))
			        {
			        	var newValue = attribute.value + "(this)";
			        	compChild.removeAttribute(attribute.name);
						compChild.setAttribute(attribute.name,newValue);
			        }
				});
				if(compChild)
				{
					if(compChild.hasAttribute("accessor-name"))
					{
						cellItem[compChild.getAttribute("accessor-name")] = compChild;
					}
				}
				this.__setRendererProperties(compChild);
			}
		}
	};
	
	NSList.prototype.__setTemplate = function()
	{
		if(this.__templateID)
		{
			this.__template = this.util.getTemplate(this.__templateID);
		}
	};
	
	NSList.prototype.__isHoverDisabled = function(item)
	{
		if(this.__disableHoverField)
		{
			return Boolean.parse(item[this.__disableHoverField]);
		}
		if(this.__disableHoverFunction)
		{
			return Boolean.parse(this.__disableHoverFunction(item,this.__fieldIndex));
		}
		return false;
	};
	
	NSList.prototype.__itemClickHandler = function(event)
	{
		event = this.util.getEvent(event);
	    var target = this.util.getTarget(event);
	    target = this.util.findParent(target,"li");
	    var index = this.__getIndexFromTarget(target);
	    this.__setIndex(index,false);
	    this.__lastNavigationDirection = null;
	};
	
	NSList.prototype.__setIndex = function(index,isMultiSelect)
	{
		if(index > -1)
		{
			isMultiSelect = Boolean.parse(isMultiSelect);
			if (this.__isShiftPressed && this.__enableMultipleSelection)
		    {
		    	this.__multiSectionHandler(index);
		    }
		    else if(isMultiSelect || (this.__isCtrlPressed && this.__enableMultipleSelection))
		    {
		    	if(this.__isRowSelected(index))
		    	{
		    		this.__markRowUnselected(index);
		    	}
		    	else
		    	{
		    		this.__markRowSelected(index);
		    	}
		    }
		    else
		    {
		    	this.__clearAllRowSelection(false);
		    	this.__markRowSelected(index);
		    } 
		}
	};
	
	NSList.prototype.__itemMouseOverHandler = function(event)
	{
		 var target = this.util.getTarget(event);
	     target = this.util.findParent(target,"li");
	     var index = this.__getIndexFromTarget(target);
	     var item = this.__getItemByIndex(index);
	     if(target && index > -1 && this.__isMouseHoverAllowed(index))
	     {
	    	 this.util.addStyleClass(target,"nsListItemHover");
	    	 this.__navigationIndex = index;
	    	 this.util.dispatchEvent(this.__baseComponent,this.ITEM_NAVIGATED,item,{index:this.__navigationIndex});
	     }
	};
	
	NSList.prototype.__itemMouseOutHandler = function(event)
	{
		 var target = this.util.getTarget(event);
	     target = this.util.findParent(target,"li");
	     if(target)
	     {
	    	 this.util.removeStyleClass(target,"nsListItemHover");
	     }
	};
	
	NSList.prototype.__keyDownHandler = function(event)
	{
		event = this.util.getEvent(event);
		if(this.hasFocus())
		{
			this.__isShiftPressed = event.shiftKey;
			this.__isCtrlPressed = event.ctrlKey;
			var isShiftCtrlPressed = this.__isShiftPressed || this.__isCtrlPressed;
			var keyCode = this.util.getKeyUnicode(event);
			if(this.__enableKeyboardNavigation)
			{
				var source = this.__objGrid.__getFlatSource();
				//key Up
				if(keyCode === this.util.KEYCODE.UP && isShiftCtrlPressed && this.__enableMultipleSelection)
				{
					if(this.__lastNavigationDirection && this.__lastNavigationDirection === this.NAVIGATION_DOWN)
					{
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_UP);
					}
					if(this.__selectedIndex != 0)
					{
						this.__selectedIndex--;
						this.__navigationIndex--;
						while(!this.__isMouseHoverAllowed(this.__selectedIndex))
						{
							this.__selectedIndex--;
							this.__navigationIndex--;
						}
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_UP);
					}
				}
				//key down
				else if(keyCode === this.util.KEYCODE.DOWN && isShiftCtrlPressed && this.__enableMultipleSelection)
				{
					if(this.__lastNavigationDirection && this.__lastNavigationDirection === this.NAVIGATION_UP)
					{
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_DOWN);
					}
					if(source && this.__selectedIndex != source.length - 1)
					{
						this.__selectedIndex++;
						this.__navigationIndex++;
						while(!this.__isMouseHoverAllowed(this.__selectedIndex))
						{
							this.__selectedIndex++;
							this.__navigationIndex++;
						}
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_DOWN);
					}
				}
				else if(keyCode === this.util.KEYCODE.UP)
				{
					if(source && this.__navigationIndex === -1)
					{
						this.__navigationIndex = source.length - 1;
					}
					if(this.__navigationIndex > 0)
					{
						return this.__keyBoardNavigationHandler(event,this.NAVIGATION_UP);
					}
				}
				else if(keyCode === this.util.KEYCODE.DOWN)
				{
					/*if(this.__navigationIndex === -1)
					{
						this.__navigationIndex = 0;
					}*/
					if(source)//&& this.__navigationIndex < source.length
					{
						return this.__keyBoardNavigationHandler(event,this.NAVIGATION_DOWN);
					}
				}
				else if(keyCode === this.util.KEYCODE.ENTER)
				{
					this.__clearAllRowSelection(false);
					var listItem = this.__getkeyboardNavigationListItem();
					if(listItem)
					{
						this.__markRowSelected(this.__getIndexFromTarget(listItem));
					}
				}
			}
			if(keyCode === this.util.KEYCODE.SHIFT)
			{
				this.util.makeBodyUnselectable();
			}
		}
	};
	
	NSList.prototype.__keyUpHandler = function(event)
	{
		if(this.util.getKeyUnicode(event) === this.util.KEYCODE.CTRL)
		{
			this.__isCtrlPressed = false;
		}
		if(this.util.getKeyUnicode(event) === this.util.KEYCODE.SHIFT)
		{
			this.__isShiftPressed = false;
			this.util.makeBodySelectable();
		}
	};
	
	NSList.prototype.__keyBoardNavigationHandler = function(event,direction)
	{
		var self = this;
		var lastIndex = this.__navigationIndex;
		var currentIndex = this.__navigationIndex;
		(direction === this.NAVIGATION_UP) ? currentIndex--:currentIndex++;
		while(!this.__isMouseHoverAllowed(currentIndex))
		{
			(direction === this.NAVIGATION_UP) ? currentIndex--:currentIndex++;
		}
		var endHandler = function()
		{
			self.__navigationIndex = currentIndex;
			var listItem = self.__getkeyboardNavigationListItem();
			var index = -1;
			var item = null;
			if(listItem)
			{
				var source = self.__objGrid.__getFlatSource();
				index = self.__getIndexFromTarget(listItem);
				item = self.__getItemByIndex(index, source);
			}
			self.util.dispatchEvent(self.__baseComponent,self.ITEM_NAVIGATED,item,{index:index});
			self.__lastNavigationDirection = null;
		};
		if(this.__enableVirtualScroll)
		{
			
			var virtualHandler = function()
			{
				//self.__setVirtualRowHover.call(self,index);
				var item = self.__getVisibleItemByIndex.call(self,null,currentIndex);
				if(item)
				{
					var index = item[self.__fieldIndex];
					self.__setVirtualRowHoverField.call(self,index);
					self.__virtualRowHover.call(self);
					endHandler();
				}
			};
			this.scrollToIndex(currentIndex,false);
			
			setTimeout(function()
			{ 
				virtualHandler();
			},0);
			//this.__setVirtualRowHover(currentIndex);
		}
		else
		{
			var listItem = this.__getListItemFromContainer(lastIndex - this.__startArrayElement);
			var currentListItem = this.__getListItemFromContainer(currentIndex - this.__startArrayElement);
			//var listItem = this.__getListItemByIndex(lastIndex - this.__startArrayElement);
			//var currentListItem = this.__getListItemByIndex(currentIndex - this.__startArrayElement);
			if(currentListItem)
			{
				this.util.removeStyleClass(listItem,"nsListItemHover");
				this.util.addStyleClass(currentListItem,"nsListItemHover");
				this.__refreshScrollPosition(currentListItem,direction);
				endHandler();
			}
		}
		
		event.preventDefault();
		return false;
	};
	
	NSList.prototype.__keyBoardSelectionHandler = function(event,direction)
	{
		if(this.__isRowSelected(this.__selectedIndex))
		{
			this.__markRowUnselected(this.__selectedIndex);
		}
		else
		{
			this.__markRowSelected(this.__selectedIndex);
		}
		if(direction === this.NAVIGATION_DOWN)
		{
			if(this.__enableVirtualScroll)
			{
				this.scrollToIndex(this.__selectedIndex,false);
			}
			else if(Math.floor(this.__selectedIndex % this.__pageSize) === 0)
			{
				var listItem = this.__getListItemByIndex(this.__selectedIndex);
				this.__refreshScrollPosition(listItem,this.NAVIGATION_DOWN);
			}
		}
		else if(direction === this.NAVIGATION_UP)
		{
			if(this.__enableVirtualScroll)
			{
				this.scrollToIndex(this.__selectedIndex,false);
			}
			else
			{
				var listItem = this.__getListItemByIndex(this.__selectedIndex);
				this.__refreshScrollPosition(listItem,this.NAVIGATION_UP);
			}
		}
		this.__lastNavigationDirection = direction;
		event.preventDefault();
		return false;
	};
	
	NSList.prototype.__refreshScrollPosition = function(listItem,direction)
	{
		if(!this.__isElementInView(listItem))
		{
			this.__scrollToListItem(listItem);
		}
	};
	
	NSList.prototype.__isElementInView = function(listItem)
	{
		var cellBottom = 0;
	    var parentBottom = 0;
	    var cellTop = 0;
	    var parentTop = 0;
		if(listItem)
		{
			var scrollParent = this.__divOuterContainer;
			var listChild = listItem.querySelector(".nsListChild");
			if(scrollParent && listChild)
			{
				var cellRect = listChild.getBoundingClientRect();
	            parentTop = 0;
	            var rectScrollParent = scrollParent.getBoundingClientRect();
	            parentBottom = rectScrollParent.height;
	            cellTop =  cellRect.top - rectScrollParent.top;
	            cellBottom = cellTop + cellRect.height;
			}
		}
		return cellBottom <= parentBottom && cellTop >= parentTop;
	};
	
	NSList.prototype.__scrollToListItem = function(listItem)
	{
		if(listItem)
		{
			var rectCell = listItem.getBoundingClientRect();
			var rectParentContainer = this.__divParentContainer.getBoundingClientRect();
	        var scrollTop = rectCell.top - rectParentContainer.top;
	        this.__divOuterContainer.scrollTop = scrollTop;
		}
	};
	
	NSList.prototype.__getkeyboardNavigationListItem = function()
	{
		var listItem = null;
		if(this.__enableVirtualScroll)
		{
			listItem = this.__listContainer.querySelector(".nsListItemHover");
		}
		else
		{
			listItem = this.__getListItemFromContainer(this.__navigationIndex);
		}
		return listItem;
	};
	
	NSList.prototype.__isMouseHoverAllowed = function(index)
	{
		var item = this.__getItemByIndex(index);
		if(item)
		{
			return !item[this.__fieldDisableHover];
		}
		return true;
	};
	
	NSList.prototype.__markRowSelected= function(index)
	{
		if(index > -1)
	    {
	        if(!this.__isRowSelected(index))
	        {
	        	this.__setMultiSelectedVars(index,true);
	            this.__setValuesForSelectedRow(index);
	        	if(this.__enableVirtualScroll)
	        	{
	        		this.__virtualRowSelection();
	        	}
	        	else
	        	{
	        		var listItem = this.__getListItemByIndex(index);
	            	this.util.addStyleClass(listItem,"nsListItemSelected"); 
	        	}
	        }
	    }
	};
	
	NSList.prototype.__markRowUnselected = function(index)
	{
	    if(this.__isRowSelected(index) && this.__isMouseHoverAllowed(index))
	    {
	    	var isUnselected = this.__setMultiSelectedVars(index,false);
	        if(isUnselected)
	        {
	        	this.__setValuesForUnselectedRow(index);
	        }
	        if(this.__enableVirtualScroll)
	    	{
	    		this.__virtualRowSelection();
	    	}
	    	else
	    	{
	    		var listItem = this.__getListItemByIndex(index);
	    		this.util.removeStyleClass(listItem,"nsListItemSelected");
	    	}
	    }
	};
	
	NSList.prototype.__setValuesForSelectedRow = function(index)
	{
		if(index > -1 && this.__isMouseHoverAllowed(index))
		{
			var item = this.__getItemByIndex(index);
			if(item)
			{
				item[this.__fieldSelected] = true;
			    this.__selectedIndex = index;
			    this.__navigationIndex = index;
			    this.util.dispatchEvent(this.__baseComponent,this.ITEM_SELECTED,item,{index:index});
			}
		}
	};
	
	NSList.prototype.__setValuesForUnselectedRow = function(index)
	{
		if(index > -1 && this.__isMouseHoverAllowed(index))
		{
			var item = this.__getItemByIndex(index);
			if(item)
			{
				item[this.__fieldSelected] = false;
		    	this.util.dispatchEvent(this.__baseComponent,this.ITEM_UNSELECTED,item,{index:index});
			}
		}
	};
	
	NSList.prototype.__clearAllRowSelection = function(setIndexVariables)
	{
		var size = this.__selectedIndexes.length;
	    for (var count = size - 1; count >= 0 ; count--)
	    {
	    	var index = this.__selectedIndexes[count];
	        this.__markRowUnselected(index);
	    }
	    this.__setMultiSelectedVars(-1,true);
	    if(setIndexVariables)
	    {
	    	this.__selectedIndex = -1;
	        this.__navigationIndex = -1;
	    }
	};
	
	NSList.prototype.__multiSectionHandler = function(lastIndex)
	{
		 if(lastIndex < 0)
		 {
			 return;
		 }
		 if (this.__selectedIndexes.length === 0)
		 {
			 this.__isRowSelected(lastIndex);
		     return;
		 }
		 var firstIndex = this.__selectedIndexes[this.__selectedIndexes.length - 1];
		 if(lastIndex === firstIndex)
		 {
			 this.__markRowUnselected(lastIndex);
			 return;
		 }
		 var isDown = lastIndex > firstIndex;
		 var isSelection = !this.__isRowSelected(lastIndex);
		 var counter = firstIndex;
		 do
		 {
			  counter = isDown ? (counter + 1) : (counter - 1);
			  if (isSelection)
			  {
				  this.__markRowSelected(counter);
			  }
			  else
			  {
				  this.__markRowUnselected(counter);
			  }
		 }
		 while(counter != lastIndex);	 
	};
	
	NSList.prototype.__setMultiSelectedVars = function(index,add)
	{
		if(index === -1)
		{
			this.__selectedItems = [];	
			this.__selectedIndexes = [];	
		}
		else if(add)
		{
			var data = this.__getItemByIndex(index);
			this.__selectedItems.push(data);
			this.__selectedIndexes.push(index);
		}
		else
		{
			var isUnselected = false;
			for (var count= 0; count < this.__selectedIndexes.length ; count++)
	        {
	            if (this.__selectedIndexes[count] === index)
	            {
	                this.__selectedItems.splice(count,1);
	                this.__selectedIndexes.splice(count,1);
	                isUnselected = true;
	                break;
	            }
	        }
			return isUnselected;
		}
		
		return true;
	};
	
	NSList.prototype.__isRowSelected= function(index)
	{
	    if(index > -1)
	    {
	    	var item = this.__getItemByIndex(index);
	    	if(item)
	    	{
	    		return item[this.__fieldSelected];
	    	}
	    }   
	    return false;
	};
	
	/******************************************************Start of Context Menu*************************************************************/
	NSList.prototype.__initializeContextMenu = function()
	{
		//if(!this.__contextMenu)
		//{
			var contextMenuSetting = {parent:this.__listContainer,isContextMenu:true,createRunTime:true,sourceProvider:this.__getContextMenuDataProvider.bind(this),targetType:"LI"};
			if(this.__contextMenuSetting)
			{
				for(var key in this.__contextMenuSetting)
				{
					//grid setting should not be overriden by the users
					if(!contextMenuSetting[key])
					{
						contextMenuSetting[key] = this.__contextMenuSetting[key];
					}
				}
			}
			this.__contextMenu = new NSMenu(contextMenuSetting);
		//}
	};
	
	NSList.prototype.__getContextMenuDataProvider = function(listItem)
	{
		if(listItem)
		{
			listItem = this.util.findParent(listItem,"LI");
			if(listItem)
			{
				var index = this.__getIndexFromTarget(listItem);
				var item = this.__getItemByIndex(index);
				if(item && this.__contextMenuProvider) 
				{
					return this.__contextMenuProvider(item,index);
				}
			}
		}
		return null;
	};
	/******************************************************End of Context Menu*************************************************************/
	/******************************Custom Function *************************************/
	NSList.prototype.__getIndexFromTarget = function(target)
	{
		if(target)
		{
			return parseInt(target.getAttribute("ns-index"));
		}
		return -1;
	};
	
	NSList.prototype.__getListItemFromItem = function(item)
	{
		var listItem = null;
		if(item)
		{
			listItem = item[this.__fieldItem];
			var index = item[this.__fieldIndex];
			//below case is true if row reference has been removed due to virtual scroll 
			var listItemRawIndex = this.__getListItemRawIndex(listItem); 
			if(!listItem || listItemRawIndex === -1)
			{
				var arrListItem = this.__listContainer.querySelectorAll('[ns-index="' + index + '"]');
				if(arrListItem && arrListItem.length > 0)
				{
					listItem = arrListItem[0];
				}
			}
		}
		return listItem;
	};
	
	NSList.prototype.__getListItemByIndex = function(index)
	{
		if(index > -1)
	    {
	    	var item = this.__getItemByIndex(index);
	    	if(item)
	    	{
	    		return item[this.__fieldItem];
	    	}
	    }   
		return null;
	};
	
	NSList.prototype.__getListItemFromContainer = function(index)
	{
		if(this.__listContainer.children.length > index)
		{
			return this.__listContainer.children[index];
		}
		return null;
	};
	
	NSList.prototype.__getItemByIndex = function(indexToFind,source)
	{
		if(!source)
		{
			source = this.__objGrid.__getFlatSource();
		}
		if(source && source.length > 0)
		{
			for(var count = 0;count < source.length;count++)
			{
				var item = source[count];
				if(item && item[this.__fieldIndex] === indexToFind)
				{
					return item;
				}
			}
		}
		return null;
	};
	
	NSList.prototype.__getIndexByItem = function(itemToFind,source)
	{
		if(!source)
		{
			source = this.__objGrid.__getFlatSource();
		}
		if(itemToFind && source && source.length > 0)
		{
			for(var count = 0;count < source.length;count++)
			{
				var item = source[count];
				if(item && item[this.__fieldIndex] === itemToFind[this.__fieldIndex])
				{
					return item[this.__fieldIndex];
				}
			}
		}
		return -1;
	};
	
	NSList.prototype.__addItem = function(arrItem,atIndex)
	{
		var flatSource = this.__objGrid.__getFlatSource();
		if(this.util.isUndefined(atIndex) || atIndex === null)
		{
			atIndex = flatSource.length;
		}
		if(arrItem && arrItem.length > 0)
		{
			if(this.__listContainer && this.__listContainer.children && this.__listContainer.children.length > 0 && this.__listContainer.children.length < 3)
			{
				for(var count = 0;count < this.__listContainer.children.length;count++)
				{
					var listItem = this.__listContainer.children[count];
					if(listItem.hasAttribute("nsNoData"))
					{
						this.__listContainer.removeChild(listItem);
						break;
					}
				}
			}
			if(!this.__addRemoveRowCallInternal)
	   	 	{
				this.__objGrid.__setWrapperSource(arrItem,atIndex,-1,0,true);
	   	 	};
			var item = null;
			var length = arrItem.length;
			var index = -1;
			for(var count = 0;count < length;count++)
			{
				item = arrItem[count];
				index = atIndex + count;
				if(item)
				{
					this.__dataSource.splice(index, 0, item);
					this.__arrWrapper.splice(index, 0, item);
					this.__arrInternalSource.splice(index, 0, item);
				}
			}
			/*flatSource = this.__objGrid.__getFlatSource();
			this.__updateSourceIndex(flatSource);*/
			for(var count = 0;count < length;count++)
			{
				item = arrItem[count];
				if(this.__enableVirtualScroll)
				{
					
				}
				else
				{
					this.__createListAt(item,item[this.__fieldIndex]);
				}
			}
		}
	};
	
	NSList.prototype.__moveItem = function(arrItem,toIndex)
	{
		if(arrItem && arrItem.length > 0 && !this.util.isUndefined(toIndex) && toIndex !== null)
		{
			var item = null;
			var length = arrItem.length;
			var index = -1;
			var fromIndex = -1;
			var listContainer = this.__listContainer;
			var listItem = null;
			for(var count = length - 1;count >= 0;count--)
			{
				item = arrItem[count];
				index = toIndex + count;
				if(item)
				{
					fromIndex = item[this.__fieldIndex];
					this.util.moveArrayItem(this.__dataSource,fromIndex,index);
					this.util.moveArrayItem(this.__arrWrapper,fromIndex,index);
					this.util.moveArrayItem(this.__arrInternalSource,fromIndex,index);
					if(this.__enableVirtualScroll)
					{
						
					}
					else
					{
						// donot use item[this.__fieldItem] for getting listItem as after de-serialization the reference get lost 
						// hence getting the item back from dataSource
						item = this.__getItemByIndex(fromIndex);
						listItem = item[this.__fieldItem];
						if(listItem)
						{
							if(listItem.parentNode === listContainer)
							{
								listContainer.removeChild(listItem);
							}
							index = (index === 0) ? index : (index - 1);
							listContainer.insertBefore(listItem, listContainer.children[index]);
						}
					}
				}
			}
		}
	};
	
	NSList.prototype.__updateSourceIndex = function(source)
	{
		if(!source)
		{
			source = this.__getAllItems();
		}
		var item = null;
		var listItem = null;
		var length = source.length;
		for(var count = 0;count < length;count++)
		{
			item = source[count];
			var index = this.__enableHierarchical ? (count + 1) : count;
			item[this.__fieldIndex] = index;
			listItem = item[this.__fieldItem];
			if(listItem && this.util.isElementOfType(listItem,"li"))
			{
				listItem.setAttribute("ns-index",index);
				var compArrow = listItem.querySelector(".nsListArrow");
				if(compArrow)
				{
					compArrow.setAttribute("ns-parent-row-count",index);
					var arrowID = this.getID() + "compArrow" + index;
					compArrow.setAttribute("id",arrowID);
					var compSvg = compArrow.querySelector("svg");
					if(compSvg)
					{
						var svgID = arrowID + "svg";
						compSvg.setAttribute("id",svgID);
					}
					var compUse = compArrow.querySelector("use");
					if(compUse)
					{
						var useID = arrowID + "use";
						compUse.setAttribute("id",useID);
					}
				}
			}
		}
	};
	
	NSList.prototype.__createArrow = function(item,parentRowCount,parentElement,isCollapsed)
	{
		 if(parentElement)
		 {
			 var cellArrowParent = this.util.createDiv(null,"nsListArrowParent");
			 var arrowID = this.getID() + "compArrow" + parentRowCount;
			 var compArrow = this.util.createDiv(arrowID,"nsListArrow");
			 compArrow.style.paddingTop = "3px";
			 compArrow.setAttribute("ns-parent-row-count",parentRowCount);
			 
			 var objSVG = new NSSvg();
			 this.__objGrid.__createArrow(compArrow,objSVG,arrowID,isCollapsed);
			 this.util.addEvent(compArrow,"click",this.__arrowClickHandler.bind(this));
			 cellArrowParent.appendChild(compArrow);
			 parentElement.appendChild(cellArrowParent);
			 item[this.__fieldItemArrow] = compArrow;
			 return compArrow;
		 }
		 return null;
	};
	
	NSList.prototype.__setArrowDirection = function(compArrow,isCollapsed)
	{
		if(compArrow)
		{
			var objSVG = new NSSvg();
			var useID = compArrow.getAttribute("id") + "use";
			this.__objGrid.__setArrowDirection(objSVG,useID,isCollapsed);
		}
	};
	
	NSList.prototype.__isArrowCollapsed = function(compArrow)
	{
		if(compArrow && compArrow.hasAttribute("ns-parent-row-count"))
		{
			var rowIndex = parseInt(compArrow.getAttribute("ns-parent-row-count"));
			var item = this.__getItemByIndex(rowIndex);
			if(item)
			{
				return item[this.__fieldIsCollapsed];
			}
		}
		return false;
	};
	
	NSList.prototype.__arrowClickHandler = function(event)
	{
		event = this.util.getEvent(event);
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"DIV");
		if(target && target.hasAttribute("ns-parent-row-count"))
		{
			var rowIndex = target.getAttribute("ns-parent-row-count");
			var isCollapse = this.__isArrowCollapsed(target);
			rowIndex = parseInt(rowIndex);
			if(rowIndex > -1)
			{
				var item = this.__getItemByIndex(rowIndex);
				if(item[this.__childField]  && item[this.__childField].length > 0)
		        {
					this.__showHideRow(rowIndex,target,!isCollapse);
		        }
				else 
				{
					this.__objGrid.__handleOnDemandClick(item,event);
				}
			}
		}
		event.stopImmediatePropagation();
	};
	
	NSList.prototype.__expandCollapseAll = function(isCollapse)
	{
		if(!this.__enableVirtualScroll && this.__getTotalListItems() < this.__totalRecords)
		{
			this.util.warning("nsList","Please let all the items to render.");
			return;
		}
		var dataSource = this.__arrInternalSource;
		if(dataSource && dataSource.length > 0)
		{
			if(this.__enableVirtualScroll)
			{
				this.__expandCollapseAllVirtual(dataSource,isCollapse);
			}
			else
			{
				this.__expandCollapseAllNormal(dataSource,isCollapse);
			}
		}
	};
	
	NSList.prototype.__expandCollapseAllNormal = function(dataSource,isCollapse)
	{
		for(var count = 0;count < dataSource.length;count++)
		{
			var item = dataSource[count];
			//setting __fieldIsCollapsed here assuming that __showHideAllArrows() will be called after this function
			item[this.__fieldIsCollapsed] = isCollapse;
			if(parseInt(item[this.__fieldItemLevel]) > 0)
			{
				var row = item[this.__fieldItem];
				if(isCollapse)
				{
					row.style.display = "none";
					item[this.__fieldItemVisible] = false;
				}
				else
				{
					row.style.display = "";
					item[this.__fieldItemVisible] = true;
				}
			}
		}
		this.__showHideAllArrows(isCollapse);
	};
	
	NSList.prototype.__expandCollapseAllVirtual = function(dataSource,isCollapse)
	{
		for(var count = 0;count < dataSource.length;count++)
		{
			var item = dataSource[count];
			//setting __fieldIsCollapsed here assuming that __showHideAllArrows() will be called after this function
			item[this.__fieldIsCollapsed] = isCollapse;
			if(parseInt(item[this.__fieldItemLevel]) > 0)
			{
				if(isCollapse)
				{
					item[this.__fieldItemVisible] = false;
				}
				else
				{
					item[this.__fieldItemVisible] = true;
				}
			}
		}
		this.__showHideAllArrows(isCollapse);
		this.__updateVisibleIndex(null,0);
		this.__setNSVirtualScroll(this.__arrInternalSource);
	};
	
	NSList.prototype.__showHideRow = function(rowIndex,compArrow,isCollapse)
	{
		if(rowIndex > -1)
		{
			var item = this.__getItemByIndex(rowIndex);
			if(!compArrow)
			{
				compArrow = this.__getArrow(item[this.__fieldIndex]);
			}
			var rowLevel = parseInt(item[this.__fieldItemLevel]);
			var arrChildItems = [];
			if(item && item[this.__fieldHasChild])
			{
				var startIndex = 0;
				if(isCollapse)
				{
					arrChildItems = this.__arrInternalSource;
					startIndex = rowIndex;
				}
				else
				{
					arrChildItems = this.__getImmediateChildItems(arrChildItems, item);
				}
				if(this.__enableVirtualScroll)
				{
					this.__showHideRowVirtual(item,arrChildItems,startIndex,rowLevel,isCollapse);
					item[this.__fieldIsCollapsed] = isCollapse;
					//this.__updateItemInSource(item);
					this.__setNSVirtualScroll(this.__arrInternalSource);
				}
				else
				{
					this.__showHideRowNormal(item,arrChildItems,startIndex,rowLevel,isCollapse);
					this.__setArrowDirection(compArrow,isCollapse);
					item[this.__fieldIsCollapsed] = isCollapse;
				}
			}
		}
	};
	
	NSList.prototype.__showHideRowNormal = function(item,arrChildItems,startIndex,rowLevel,isCollapse)
	{
		if(arrChildItems && arrChildItems.length > 0)
		{
			if(isCollapse)
			{
				var retIndex = this.__getActualIndex(arrChildItems,startIndex);
				if(retIndex !== startIndex)
				{
					startIndex = (retIndex + 1);
				}
			}
			var rowItem = null;
			for(var count = startIndex;count < arrChildItems.length;count++)
			{
				rowItem = arrChildItems[count];
				var row = rowItem[this.__fieldItem];
				if(!row)
				{
					row = this.__createListAt(rowItem,rowItem[this.__fieldIndex] - 1,false);
					rowItem[this.__fieldItem] = row;
					this.__updateSourceIndex();
				}
				if(isCollapse)
				{
					if(rowLevel >= parseInt(rowItem[this.__fieldItemLevel]))
					{
						break;
					}
					row.style.display = "none";
					rowItem[this.__fieldItemVisible] = false;
					if(rowItem[this.__fieldHasChild])
					{
						rowItem[this.__fieldIsCollapsed] = true;
						if(rowItem[this.__fieldItemArrow])
						{
							var divArrow = rowItem[this.__fieldItemArrow];
							if(divArrow)
							{
								this.__setArrowDirection(divArrow,true);
							}
						}
					}
				}
				else
				{
					row.style.display = "";
					rowItem[this.__fieldItemVisible] = true;
				}
			}
		}
	};
	
	NSList.prototype.__showHideRowVirtual = function(item,arrChildItems,startIndex,rowLevel,isCollapse)
	{
		if(arrChildItems && arrChildItems.length > 0)
		{
			if(isCollapse)
			{
				var retIndex = this.__getActualIndex(arrChildItems,startIndex);
				if(retIndex !== startIndex)
				{
					startIndex = (retIndex + 1);
				}
			}
			for(var count = startIndex;count < arrChildItems.length;count++)
			{
				var rowItem = arrChildItems[count];
				if(isCollapse)
				{
					if(rowLevel >= parseInt(rowItem[this.__fieldItemLevel]))
					{
						break;
					}
					rowItem[this.__fieldItemVisible] = false;
					if(rowItem[this.__fieldHasChild])
					{
						rowItem[this.__fieldIsCollapsed] = true;
					}
				}
				else
				{
					rowItem[this.__fieldItemVisible] = true;
				}
			}
			var index = item[this.__fieldIndex];
			this.__updateVisibleIndex(null,index - 1);
		}
	};
	
	NSList.prototype.__showHideAllArrows = function(isCollapse)
	{
		var arrDivs = this.__getAllArrows();
		if(arrDivs && arrDivs.length > 0)
		{
			for(var count = 0;count < arrDivs.length;count++)
			{
				var div = arrDivs[count];
				if(div && div.hasAttribute("ns-parent-row-count"))
				{
					this.__setArrowDirection(div,isCollapse);
				}
			}
		}
	};
	
	NSList.prototype.__getAllItems = function()
	{
		return this.__objGrid.__getFlatSource();
	};
	
	NSList.prototype.__updateListItemText = function(listItem,item,index)
	{
		return this.__objGrid.__updateListItemText(listItem,item,index);
	};
	
	NSList.prototype.__getImmediateChildItems = function(arrItems,item)
	{
		if(!arrItems)
		{
			arrItems = [];
		}
		if(item && item[this.__fieldHasChild])
		{
			var arrChild = this.__arrInternalSource;
			var rowLevel = parseInt(item[this.__fieldItemLevel]);
			var startIndex = item[this.__fieldIndex];
			var retIndex = this.__getActualIndex(arrChild,startIndex);
			if(retIndex !== startIndex)
			{
				startIndex = (retIndex + 1);
			}
			var length = arrChild.length;
			for(var count = startIndex;count < length;count++)
			{
				var itemChild = arrChild[count];
				var childRowLevel = parseInt(itemChild[this.__fieldItemLevel]);
				if(rowLevel >= childRowLevel)
				{
					break;
				}
				if((rowLevel + 1) === childRowLevel)
				{
					arrItems.push(itemChild);
				}
			}
		}
		return arrItems;
	};
	
	//generally used for Filter condition
	NSList.prototype.__getActualIndex = function(arrChild,startIndex,addCompareOne)
	{
		//(startIndex + 1) as __fieldIndex starts from 1
		if(arrChild && arrChild.length < startIndex || arrChild[startIndex][this.__fieldIndex] !== (startIndex + 1))
		{
			var compareIndex = startIndex;
			if(addCompareOne)
			{
				compareIndex += 1;
			}
			var rowItem = null;
			for(var count = 0;count < arrChild.length;count++)
			{
				rowItem = arrChild[count];
				if(rowItem[this.__fieldIndex] === compareIndex)
				{
					return count;
				}
			}
		}
		return startIndex;
	};
	
	
	NSList.prototype.__getAllChildItems = function(arrItems,item)
	{
		if(!arrItems)
		{
			arrItems = [];
		}
		if(item && item[this.__fieldHasChild])
		{
			var arrChild = this.__arrInternalSource;
			var rowLevel = parseInt(item[this.__fieldItemLevel]);
			var startIndex = item[this.__fieldIndex];
			var length = arrChild.length;
			for(var count = startIndex;count < length;count++)
			{
				var itemChild = arrChild[count];
				if(rowLevel >= parseInt(itemChild[this.__fieldItemLevel]))
				{
					break;
				}
				arrItems.push(itemChild);
			}
		}
		return arrItems;
	};
	
	NSList.prototype.__getAllVisibleItems = function()
	{
		var totalRecords = 0;
		var arrItems = this.__getAllItems();
		if(arrItems && arrItems.length > 0)
		{
			for(var count = 0;count < arrItems.length;count++)
			{
				var item = arrItems[count];
				if(item && item[this.__fieldItemVisible])
				{
					totalRecords += 1;
				}
			}
		}
		return totalRecords;
	};
	
	NSList.prototype.__getFirstVisibleItemBeforeIndex = function(itemIndex)
	{
		var arrItems = this.__getAllItems();
		if(arrItems && arrItems.length > 0)
		{
			var retIndex = this.__getActualIndex(arrItems,itemIndex);
			if(retIndex !== itemIndex)
			{
				itemIndex = (retIndex + 1);
			}
			for(var count = itemIndex;count >= 0;count--)
			{
				var item = arrItems[count];
				if(item && item[this.__fieldItemVisible] && item[this.__fieldVisibleIndex] > -1)
				{
					return item;
				}
			}
		}
		return null;
	};
	
	NSList.prototype.__getVisibleItemByIndex = function(source,index)
	{
		var arrItems = source;
		if(!arrItems)
		{
			arrItems = this.__getAllItems();
		}
		if(arrItems && arrItems.length > 0)
		{
			var self = this; 
			var findItem = function(itemCompare)
			{
				 return (itemCompare[self.__fieldVisibleIndex] === (index + 1));
			};
			return arrItems.find(findItem);
		}
		return null;
	};
	
	NSList.prototype.__updateVisibleIndex = function(source,fromIndex)
	{
		var arrItems = source;
		if(!arrItems)
		{
			arrItems = this.__getAllItems();
		}
		if(this.util.isUndefinedOrNull(fromIndex))
		{
			fromIndex = 0;
		}
		if(arrItems && arrItems.length > 0)
		{
			var visibleRowIndex = 1;
			if(fromIndex > 0)
			{
				var visibleItem = this.__getFirstVisibleItemBeforeIndex(fromIndex);
				if(visibleItem)
				{
					visibleRowIndex = visibleItem[this.__fieldVisibleIndex];
					fromIndex = visibleItem[this.__fieldIndex] - 1;
					var retIndex = this.__getActualIndex(arrItems,fromIndex,true);
					if(retIndex !== fromIndex)
					{
						fromIndex = retIndex;
					}
				}
			}
			var length = arrItems.length;
			var item = null;
			for(var count = fromIndex; count < length; count++)
			{
				item = arrItems[count];
				if(item)
				{
					if(item[this.__fieldItemVisible])
					{
						item[this.__fieldVisibleIndex] = visibleRowIndex;
						visibleRowIndex++;
					}
					else
					{
						item[this.__fieldVisibleIndex] = -1;
					}
				}
			}
		}
	};
	
	NSList.prototype.__updateVisibleIndexByListItem = function(source,arrAllItems)
	{
		if(source)
		{
			var arrItems = arrAllItems;
			if(!arrItems)
			{
				arrItems = this.__getAllItems();
			}
			var length = source.length;
			var item = null;
			var objVisibleIndex = {};
			for(var count = 0; count < length; count++)
			{
				item = source[count];
				if(item)
				{
					var index = item[this.__fieldIndex];
					objVisibleIndex[index] = "NSList";
				}
			}
			if(arrItems && arrItems.length > 0)
			{
				length = arrItems.length;
				item = null;
				var visibleRowIndex = 1;
				for(var count = 0; count < length; count++)
				{
					item = arrItems[count];
					var index = item[this.__fieldIndex];
					if(this.util.isUndefinedOrNull(objVisibleIndex[index]))
					{
						item[this.__fieldVisibleIndex] = -1;
						item[this.__fieldItemVisible] = false;
					}
					else
					{
						item[this.__fieldVisibleIndex] = visibleRowIndex;
						item[this.__fieldItemVisible] = true;
						visibleRowIndex++;
					}
				}
			}
			
		}
	};
	
	NSList.prototype.__updateIndexForAllItems = function(source)
	{
		if(!source)
		{
			source = this.__getAllItems();
		}
		var length = source.length;
		var item = null;
		for(var count = 0; count < length; count++)
		{
			item = source[count];
			if(item)
			{
				item[this.__fieldIndex] = count;
			}
		}
	};
	
	NSList.prototype.__getArrow = function(rowCount)
	{
		var arrDivs = this.__getAllArrows();
		if(arrDivs && arrDivs.length > 0)
		{
			for(var count = 0;count < arrDivs.length;count++)
			{
				var div = arrDivs[count];
				if(div && div.hasAttribute("ns-parent-row-count"))
				{
					var rowParentCount = div.getAttribute("ns-parent-row-count");
					if(rowParentCount && rowParentCount == rowCount)
					{
						return div;
					}
				}
			}
		}
		return null;
	};
	
	NSList.prototype.__getAllArrows = function(divParent)
	{
		if(!divParent)
		{
			divParent = this.__listContainer;
		}
		return divParent.querySelectorAll(".nsListArrow");
	};
	
	NSList.prototype.__getTotalListItems = function()
	{
		if(this.__listContainer && this.__listContainer.children)
		{
			return this.__listContainer.children.length;
		}
		return 0;
	};
	
	NSList.prototype.__updateTotalRecords = function(totalCount)
	{
		if(this.util.isUndefined(totalCount) || totalCount === null)
		{
			totalCount = this.__arrInternalSource.length; 
		}
		this.__totalRecords = totalCount;
	};
	
	NSList.prototype.__getListItemRawIndex = function(listItem)
	{
		if(listItem && listItem.parentNode)
		{
			var index = [].slice.call(listItem.parentNode.children).indexOf(listItem);
			return index;
		}
		return -1;
	};
	
	NSList.prototype.__checkForVirtualMode = function()
	{
		if(this.__enableVirtualScroll)
		{
			if(this.__enablePagination)
			{
				this.__enableVirtualScroll = false;
			}
		}
	};
	
	NSList.prototype.__setVirtualScroll_ScrollTop = function(scrollTop)
	{
		if(this.__enableCustomScrollBar)
		{
			if(this.__scroller)
			{
				this.__scroller.setScrollTop(scrollTop);
			}
		}
	};
	
	var NSFlatList = function(nsList)
	{
		this.__nsList = nsList;
		this.util = nsList.util;
		/********************************Common Functions for Grid ****************************************/
		this.__initialize = function()
		{
		};
		
		this.dataSource = function(source)
		{
			this.__nsList.__arrWrapper = this.__nsList.__dataSource.slice(0);
			this.__setWrapperSource(this.__nsList.__arrWrapper,0,-1,0,true);
			this.__nsList.__arrInternalSource = this.__nsList.__arrWrapper.slice(0);
			this.__nsList.__updateTotalRecords();
		};
		
		this.addItemsAsChildren = function(item,arrChildren)
		{
		};
		
		this.__setWrapperSource = function(source,offset,parentIndex,level,setFieldIndex)
		{
			if(source)
			{
				if(!offset)
				{
					offset = 0;
				}
				var length = source.length;
				var count = 0;
				var item = null;
				var index = -1; 
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					index = offset + count;
					this.__setItemProperty(item,index,setFieldIndex);
				}
			}
		};
	
		this.__createList= function(dataSet,startIndex,endIndex)
		{
			var item = null;
			var index = -1;
		    for(var count = startIndex; count < endIndex; count++)
		     {
	    		item = dataSet[count];
	    		index =  item[this.__nsList.__fieldIndex];
	    		this.__nsList.__updateItem(item,index);
	    		this.__nsList.__createListItem(item);
		     }
		};
		
		this.__createListItem = function(listItem,item)
		{
		};
	
		this.__addSVGInPage = function()
		{
		};
	
		this.__setListItemProperties = function(listItem,item)
		{
			if(listItem && item)
			{
				var index = item[this.__nsList.__fieldIndex];
				listItem.setAttribute("ns-index",index);
				item[this.__nsList.__fieldItem] = listItem;
				this.util.removeAllChildren(listItem);
				var divCell = this.util.createDiv(null,"nsListChild");
				this.util.addStyleClass(divCell,this.__nsList.__CLASS_CELL_CHILD);
				listItem.appendChild(divCell);
				this.__nsList.__addCellText(listItem,item,divCell);
			}
		};
		
		this.__updateListItemText = function(listItem,item,index)
		{
			if(listItem && item)
			{
				this.util.removeAllChildren(listItem);
				this.__setListItemProperties(listItem,item);
			}
		};
	
		this.__getFlatSource= function()
		{
			return this.__nsList.__arrWrapper;
		};
		/********************************Common Functions for Grid ****************************************/
		this.__setItemProperty = function(item,rowIndex,setFieldIndex)
		{
			if(item)
			{
				if(setFieldIndex)
				{
					item[this.__nsList.__fieldIndex] = rowIndex;
				}
				item[this.__nsList.__fieldVisibleIndex] = rowIndex + 1;
			}
		};
	
		this.__resetListItem = function(listItem,index,item)
		{
			listItem.style.display = "";
			listItem.setAttribute("ns-index",index);
			this.util.removeStyleClass(listItem,"nsListItemSelected");
			this.__nsList.__updateItem(item,index);
			this.__setListItemProperties(listItem,item);
		};
	};
	
	var NSHierarchicalList = function(nsList)
	{
		this.__nsList = nsList;
		this.util = nsList.util;
		this.__ARROW_COLLAPSE_PATH = "M 0 9.99994L 6.10352e-005 -3.05176e-005L 5 5.00006L 0 9.99994 Z";
		this.__ARROW_EXPANDED_PATH = "M 0 3.05176e-005L 9.99994 9.15527e-005L 4.99988 5.00003L 0 3.05176e-005 Z";
		this.__CLASS_ARROW = "nsListArrowFill";
		this.__rowCounter = -1;
		this.__enableOnDemandHierarchy = false;
		this.__onDemandChildDetectionField = "hasChildren";
		this.__onDemandChildFetchCallback = null;
		/********************************Common Functions for Grid ****************************************/
		this.__initialize = function()
		{
			var setting = this.__nsList.__setting;
			if(setting.hasOwnProperty("enableOnDemandHierarchy"))
			{
				this.__enableOnDemandHierarchy = Boolean.parse(setting["enableOnDemandHierarchy"]);
			}
			if(this.__enableOnDemandHierarchy)
			{
				if(setting.hasOwnProperty("onDemandChildDetectionField"))
				{
					this.__onDemandChildDetectionField = setting["onDemandChildDetectionField"];
				}
				if(setting.hasOwnProperty("onDemandChildFetchCallback"))
				{
					this.__onDemandChildFetchCallback = setting["onDemandChildFetchCallback"];
					this.__onDemandChildFetchCallback = this.util.getFunction(this.__onDemandChildFetchCallback);
				}
				if(!this.__onDemandChildDetectionField)
				{
					this.util.throwNSError("NSList","Value for onDemandChildDetectionField is not valid");
				}
				if(!this.__onDemandChildFetchCallback)
				{
					this.util.throwNSError("NSList","Value for onDemandChildFetchCallback is not valid");
				}
				if(this.__enableVirtualScroll)
				{
					this.util.warning("NSList","As enableVirtualScroll is true so OnDemandHierarchy will have no impact.");
				}
			}
		};
		
		this.dataSource = function(source)
		{
			this.__nsList.__arrWrapper = this.__nsList.__dataSource.slice(0);
			this.__setWrapperSource(this.__nsList.__arrWrapper,0,-1,0,true,true,true);
			this.__nsList.__updateTotalRecords(this.__rowCounter);
			this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0);
		};
		
		this.addItemsAsChildren = function(item,arrChildren)
		{
			if(item && arrChildren && arrChildren.length > 0)
			{
				if(!item[this.__nsList.__childField])
				{
					item[this.__nsList.__childField] = [];
				}
				item[this.__nsList.__childField].push.apply(item[this.__nsList.__childField], arrChildren);
				this.__setWrapperSource(this.__nsList.__arrWrapper,0,-1,0,true,false,false);
				this.__nsList.__updateTotalRecords(this.__rowCounter);
				this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0);
				item[this.__nsList.__fieldItemVisible] = true;
				item[this.__nsList.__fieldIsCollapsed] = false;
		   		var listItem = this.__nsList.__getListItemFromItem(item);
		   		var rowIndex = this.__nsList.__getIndexByItem(item);
		   		this.__nsList.__showHideRow(rowIndex,null,false);
		   		console.log(this.__nsList.__arrFlatHierarchicalSource);
			}
		};
		
		this.__setWrapperSource = function(source,offset,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible)
		{
			if(source)
			{
				if(level === 0)
				{
					if(!offset)
					{
						offset = 0;
					}
					this.__nsList.__arrFlatHierarchicalSource = [];
					this.__rowCounter = offset;
				}
				var length = source.length;
				var count = 0;
				var item = null;
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					this.__rowCounter++;
					this.__nsList.__arrFlatHierarchicalSource.push(item);
					this.__setItemProperty(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible);
				}
			}
		};
	
		this.__createList= function(dataSet,startIndex,endIndex)
		{
			var item = null;
			var index = -1;
		    for(var count = startIndex; count < endIndex; count++)
		    {
	    		item = dataSet[count];
	    		if(item)
	    		{
	    			index =  item[this.__nsList.__fieldIndex];
	        		this.__nsList.__updateItem(item,index);
	        		this.__nsList.__createListItem(item);
	    		}
		    }
		};
		
		this.__createListItem = function(listItem,item)
		{
		};
	
		this.__addSVGInPage = function()
		{
			var objSVG = new NSSvg();
			objSVG.addPath("svgListArrowDown",this.__ARROW_EXPANDED_PATH,"0 0 16 16");
			objSVG.addPath("svgListArrowRight",this.__ARROW_COLLAPSE_PATH,"0 0 16 16");
		};
	
		this.__setListItemProperties = function(listItem,item)
		{
			if(listItem && item)
			{
				var index = item[this.__nsList.__fieldIndex];
				var level = item[this.__nsList.__fieldItemLevel];
				var parentIndex = item[this.__nsList.__fieldParentIndex];
				listItem.setAttribute("ns-index",index);
				listItem.setAttribute("ns-level",level);
				if(item[this.__nsList.__fieldHasParent])
			    {
					listItem.setAttribute("ns-parent-index",parentIndex);
			    }
				item[this.__nsList.__fieldItem] = listItem;
				this.util.removeAllChildren(listItem);
				var divCell = this.util.createDiv(null,"nsListChild");
				listItem.appendChild(divCell);
				
				var hierarchicalPadding = 0;
				var divText = null;
				if(item && item.hasOwnProperty(this.__nsList.__labelField) && item[this.__nsList.__labelField])
				{
			        if((item[this.__nsList.__childField]  && item[this.__nsList.__childField].length > 0) || (this.__isOnDemandHasChildren(item)))
			        {
			        	this.util.addStyleClass(divCell,this.__nsList.__CLASS_GROUP_CELL);
			        	this.__nsList.__createArrow(item,index,divCell,item[this.__nsList.__fieldIsCollapsed]);
			        	var cellText = this.util.createDiv(null,this.__nsList.__CLASS_CELL_CHILD);
			        	this.util.addStyleClass(cellText,"nsListGroupCellText");
			        	cellText.style.verticalAlign = "top";
			        	divText = cellText;
			        	divCell.appendChild(cellText);
			        }
			        else
			        {
			        	this.util.addStyleClass(divCell,this.__nsList.__CLASS_CELL_CHILD);
			        	divText = divCell;
			        	//24 = 16(Arrow Width) + 6(Arrow Parent Padding) + 2(divCell horizontalGap between elements shown in debugger)
			        	hierarchicalPadding = 24;
			        }
			        this.__nsList.__addCellText(listItem,item,divText);
		        	if(level === 0)
		        	{
		        		listItem.style.paddingLeft = "1px";
		        	}
		        	else
		        	{
		        		var paddingLeft = (10 * level) + hierarchicalPadding;
		        		listItem.style.paddingLeft = paddingLeft + "px";
		        	}
				}
			}
		};
		
		this.__updateListItemText = function(listItem,item,index)
		{
			if(listItem && item)
			{
				this.util.removeAllChildren(listItem);
				this.__setListItemProperties(listItem,item);
			}
		};
	
		this.__getFlatSource= function()
		{
			return this.__nsList.__arrFlatHierarchicalSource;
		};
		
		this.__handleOnDemandClick = function(item,event)
		{
			if(item && this.__isOnDemandHasChildren(item))
			{
				if(this.__onDemandChildFetchCallback)
				{
					event = this.util.getEvent(event);
					var rowLevel = item[this.__nsList.__fieldItemLevel];
					var rowIndex = this.__nsList.__getIndexByItem(item);
					this.__onDemandChildFetchCallback(item,rowIndex,rowLevel,event);
				}
			}
		};
		/********************************Common Functions for Grid ****************************************/
		this.__setItemProperty = function(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible)
		{
			if(item)
			{
				if(this.util.isUndefinedOrNull(setIsCollapsed))
				{
					setIsCollapsed = true;
				}
				if(this.util.isUndefinedOrNull(setItemVisible))
				{
					setItemVisible = true;
				}
				var totalRowCount = this.__rowCounter;
				if(setFieldIndex || this.util.isUndefinedOrNull(item[this.__nsList.__fieldIndex]))
				{
					item[this.__nsList.__fieldIndex] = totalRowCount;
				}
				item[this.__nsList.__fieldVisibleIndex] = totalRowCount;
				item[this.__nsList.__fieldItemLevel] = level;
				var hasChild = false;
				if(item.hasOwnProperty(this.__nsList.__childField) && item[this.__nsList.__childField] && item[this.__nsList.__childField].length > 0)
			    {
			    	hasChild = true;
			    	this.__setWrapperSource(item[this.__nsList.__childField],0,totalRowCount,level + 1,setFieldIndex,setIsCollapsed,setItemVisible);
			    }
				item[this.__nsList.__fieldParentIndex] = parentIndex;
				if(parentIndex > -1)
			    {
					item[this.__nsList.__fieldHasParent] = true;
			    }
				else
				{
					item[this.__nsList.__fieldHasParent] = false;
				}
				item[this.__nsList.__fieldHasChild] = hasChild;
				if(setItemVisible || this.util.isUndefinedOrNull(item[this.__nsList.__fieldItemVisible]))
				{
					item[this.__nsList.__fieldItemVisible] = true;
				}
				if(setIsCollapsed || this.util.isUndefinedOrNull(item[this.__nsList.__fieldIsCollapsed]))
				{
					item[this.__nsList.__fieldIsCollapsed] = this.__isOnDemandHasChildren(item);
				}
			}
		};
		
		this.__createArrow = function(compArrow,objSVG,arrowID,isCollapsed)
		{
			 var svg = objSVG.addSVG(compArrow,arrowID + "svg",this.__CLASS_ARROW,null,null,null,null,null,null,true);
			 if(isCollapsed)
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgListArrowRight");
			 }
			 else
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgListArrowDown");
			 }
		};
	
		this.__setArrowDirection = function(objSVG,useID,isCollapsed)
		{
			if(isCollapsed)
			{
				objSVG.changeUseHref(useID,"#svgListArrowRight");
			}
			else
			{
				objSVG.changeUseHref(useID,"#svgListArrowDown");
			}
		};
	
		this.__resetListItem = function(listItem,index,item)
		{
			listItem.style.display = "";
			listItem.setAttribute("ns-index",index);
			this.util.removeStyleClass(listItem,"nsListItemSelected");
			this.__nsList.__updateItem(item,index);
			this.__setListItemProperties(listItem,item);
		};
		
		this.__isOnDemandHasChildren = function(item)
		{
			return (this.__enableOnDemandHierarchy && item[this.__onDemandChildDetectionField]);
		};
	};
	
	var NSListFilter = function(nsList)
	{
		this.__nsList = nsList;
		
		this.util = nsList.util;
		this.__filteredColumn = [];
		this.__config = {};
		this.__nsDragDrop = null;
		
		this.__initialize = function()
		{
			
		};
		
		this.filter = function(strData,filterSetting,enableHighlighting,recordLimit)
		{
			if(!filterSetting)
			{
				filterSetting = {};
			}
			if(this.util.isUndefinedOrNull(enableHighlighting))
			{
				enableHighlighting = true;
			}
			var config = {
					caseSensitive: this.util.isUndefinedOrNull(filterSetting["caseSensitive"]) ? false : Boolean.parse(filterSetting["caseSensitive"]),
					multiline: this.util.isUndefinedOrNull(filterSetting["multiline"]) ? false : Boolean.parse(filterSetting["multiline"]),
					matchType: filterSetting["matchType"] || new NSFilter().CONTAINS
			};
			var filter = {};
			var setting = {};
			var field = this.__nsList.__labelField;
			filter[field] = strData;
			setting[field] = {caseSensitive:config["caseSensitive"],multiline:config["multiline"],matchType:config["matchType"]};
			if(filter && Object.keys(filter).length > 0)
			{
				this.__handleFiltering(filter,setting,enableHighlighting,recordLimit);
			}
			else
			{
				this.__resetFiltering();
			}
		};
		
		this.reset = function()
		{
			this.__resetFiltering();
		};
		
		this.__handleFiltering = function(filter,setting,enableHighlighting,recordLimit)
		{
			this.__filteredColumn = [];
			if(filter)
		    {
				 var field = this.__nsList.__labelField;
				 var source = this.__nsList.__arrWrapper;
				 var isHierarchical = false;
				 if(this.__nsList.__enableHierarchical)
				 {
					 isHierarchical = true;
				 }
			   	 var nsFilter = new NSFilter(source,filter,setting,recordLimit,isHierarchical,this.__nsList.__childField);
			   	 this.__nsList.__arrInternalSource = nsFilter.execute();
			   	 if(enableHighlighting)
			   	 {
			   		for(var key in filter) 
		  	        {
		  	        	this.__filteredColumn.push({field:key,text:filter[key]});
		  	        }
			   	 }
			   	 if(isHierarchical)
			   	 {
			   		this.__nsList.__objGrid.__setWrapperSource(this.__nsList.__arrInternalSource,0,-1,0,false);
			   		this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0); 
			   	 }
			   	 this.__nsList.__updateTotalRecords();
			   	 this.__nsList.__renderBody();
			   	 this.__nsList.__updateVisibleIndexByListItem(this.__nsList.__arrInternalSource);
		    }
		};
	
		this.__resetFiltering = function()
		{
			if(this.__nsList.__dataSource)
			{
				this.__nsList.__arrInternalSource = this.__nsList.__arrWrapper.slice(0);
				this.__filteredColumn = [];
				if(this.__nsList.__enableHierarchical)
				{
					this.__nsList.__objGrid.__setWrapperSource(this.__nsList.__arrInternalSource,0,-1,0,false);
					this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0); 
				}
				this.__nsList.__updateTotalRecords();
				this.__nsList.__renderBody();
				this.__nsList.__updateVisibleIndexByListItem(this.__nsList.__arrInternalSource);
			}
		};
	
		this.__highlightDiv = function(divText)
		{
			var length = this.__filteredColumn.length;
			for (var count = 0; count < length; count++) 
		    {
				var text = this.__filteredColumn[count].text;
				this.util.highlightText(divText,text,"nsTextHighlight");
		    }
		};
		
		this.__initialize();
	};
	
	var NSListDragDrop = function(nsList)
	{
		this.__nsList = nsList;
		this.util = nsList.util;
		
		this.__disableDraggableFunction = null;
		this.__disableDropableFunction = null;
		
		this.initialize = function()
		{
			var container = this.__nsList.__listContainer;
			var setting = {container:container,childNodeType:"LI",isContainerDraggable:this.__nsList.__isDraggable,isContainerDroppable:this.__nsList.__isDroppable,
						   enableDragByHandle:this.__nsList.__enableDragByHandle,dragHandlerClass:this.__nsList.__dragHandlerClass,
						   enableDragAfterHold:this.__nsList.__enableDragAfterHold,enableCloneMode:this.__nsList.__enableCloneMode,holdTime:this.__nsList.__holdTime,createCloneCallback:this.__createClone.bind(this),
						   createPlaceholderCallback:this.__createPlaceholder.bind(this),nodeDroppableCallback:this.__isListItemDroppable.bind(this),
						   nodeDraggableCallback:this.__isListItemDraggable.bind(this),insertNodeCallback:this.__insertListItemHandler.bind(this),
						   moveNodeCallback:this.__moveListItemHandler.bind(this),removeNodeCallback:this.__removeListItemHandler.bind(this)};
			this.__nsDragDrop = new NSDragDrop(setting);
			this.util.addEvent(container,this.__nsDragDrop.ITEM_DROPPING,this.__itemDroppingHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.ITEM_DROPPED,this.__itemDroppedHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAG_STARTING,this.__dragStartingHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAG_STARTED,this.__dragStartHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAGGING,this.__draggingHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAG_END,this.__dragEndHandler.bind(this));
		};
		
		this.__initialize = function()
		{
			var setting = this.__nsList.__setting;
			if(setting.hasOwnProperty("disableDraggableFunction"))
			{
				this.__disableDraggableFunction = setting["disableDraggableFunction"];
				this.__disableDraggableFunction = this.util.getFunction(this.__disableDraggableFunction);
			}
			if(setting.hasOwnProperty("disableDropableFunction"))
			{
				this.__disableDropableFunction = setting["disableDropableFunction"];
				this.__disableDropableFunction = this.util.getFunction(this.__disableDropableFunction);
			}
		};
		
		this.__dragStartingHandler = function(event)
		{
			var listItem = event.node;
			var arrItems = this.__getSelectedItems(listItem);
			var data = {parentID:this.__nsList.__listContainer.getAttribute("id"),arrItems:arrItems};
			this.__nsDragDrop.setDragData(data);
		};
		
		this.__dragStartHandler = function(event)
		{
			var listItem = event.node;
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
			this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.DRAG_STARTED,arrItems,{items:arrItems});
		};
		
		this.__draggingHandler = function(event)
		{
			var listData = event.item;
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
			listData.arrItems = arrItems;
	 	    this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.DRAGGING,listData,{item:listData});
		};
		
		this.__dragEndHandler = function(event)
		{
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
	 	    this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.DRAG_END,arrItems,{items:arrItems});
		};
		
		this.__itemDroppingHandler = function(event)
		{
			var cancelled = this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.ITEM_DROPPING,event.item,{item:event.item},true,true);
			if(cancelled)
			{
				event.preventDefault();
			}
		};
		
		this.__itemDroppedHandler = function(event)
		{
			this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.ITEM_DROPPED,event.item,{item:event.item},true,false);
		};
		
		this.__createClone = function(listItem,containerConfiguration)
		{
			var listContainer = this.__nsList.__listContainer.cloneNode(false);
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
			var clonedNode = null;
			//make a clone only when clone Mode is ON or the list is not droppable
			if(this.__nsList.__enableCloneMode || !this.__nsList.__isDroppable)
			{
				for(var count = 0;count < arrItems.length;count++)
				{
					clonedNode = arrItems[count][this.__nsList.__fieldItem].cloneNode(true);
					clonedNode.setAttribute("id","comp" + listContainer.id + "ClonedNode" + count);
					listContainer.appendChild(clonedNode);
				}
			}
			else
			{
				for(var count = 0;count < arrItems.length;count++)
				{
					clonedNode = arrItems[count][this.__nsList.__fieldItem];
					listContainer.appendChild(clonedNode);
				}
			}
			listContainer.style.width = containerConfiguration.width + "px";
			return listContainer;
		};
		
		this.__createPlaceholder = function(listItem)
		{
			var listItem = this.util.createElement("li",null,"nsListEmptyItem");
			listItem.innerHTML = "<div class='nsListEmptyChild'>&nbsp;</div>";
			return listItem;
		};
		
		this.__isListItemDroppable = function(listItem)
		{
			var item = this.__getItemFromTarget(listItem);
			return this.__isItemDroppable(listItem,item);
		};
		
		this.__isListItemDraggable = function(listItem)
		{
			var item = this.__getItemFromTarget(listItem);
			return this.__isItemDraggable(listItem,item);
		};
		
		this.__insertListItemHandler = function(container,newListItem,index,currentListItem,data)
		{
			var arrItems = data.arrItems;
			this.__nsList.__addItem(arrItems,index);
		};
		
		this.__moveListItemHandler = function(container,newListItem,index,currentListItem,data)
		{
			var arrItems = data.arrItems;
			this.__nsList.__moveItem(arrItems,index);
		};
		
		this.__removeListItemHandler = function(container,listItem,data)
		{
			
		};
		
		this.__getSelectedItems = function(target)
		{
			var list = this.__nsList;
			var listContainer = list.__listContainer;
			var index = parseInt(list.__getIndexFromTarget(target));
			var item = list.__getItemByIndex(index);
			var arrItems = [];
			var arrSelectedItems = list.getSelectedItems();
			var itemSelected = false; 
			if(arrSelectedItems && arrSelectedItems.length > 0)
			{
				var tempItem = null;
				for(var count = 0;count < arrSelectedItems.length;count++)
				{
					tempItem = this.__cloneItem(arrSelectedItems[count]);
					if(tempItem[list.__fieldIndex] === item[list.__fieldIndex])
					{
						itemSelected = true;
					}
					arrItems.push(tempItem);
				}
			}
			if(!itemSelected || !arrItems || arrItems.length === 0 || !arrItems[0])
			{
				var tempItem = this.__cloneItem(item);
				arrItems = [tempItem];
			}
			return arrItems;
		};
		
		this.__cloneItem = function(item)
		{
			var list = this.__nsList;
			var tempItem = null;
			if(item)
			{
				tempItem = this.util.cloneObject(item);
				if(list.__enableHierarchical && tempItem[list.__childField] && tempItem[list.__childField].length > 0)
				{
					var arrChild = tempItem[list.__childField];
					var length = arrChild.length;
					var childItem = null;
					var tempChildItem = null;
					for(var count = 0;count < length;count++)
					{
						childItem = arrChild[count];
						tempChildItem = this.__cloneItem(childItem);
						if(tempChildItem)
						{
							tempItem[list.__childField][count] = tempChildItem;
						}
					}
				}
			}
			return tempItem;
		};
		
		this.__getItemFromTarget = function(listItem)
		{
			var itemIndex = this.__nsList.__getIndexFromTarget(listItem);
			return this.__nsList.__getItemByIndex(itemIndex);
		};
		
		this.__isItemDraggable = function(listItem,item) 
	    {
			var retValue = true;
			if(this.__disableDraggableFunction)
			{
				retValue = this.__disableDraggableFunction(item,this.__nsList.__labelField,item[this.__nsList.__fieldIndex],item[this.__nsList.__fieldDisableHover],listItem);
				retValue = !retValue;
			}
	    	return retValue;
		};
		
		this.__isItemDroppable = function(event) 
	    {
			var retValue = true;
			if(this.__disableDropableFunction)
			{
				var target = this.util.getTarget(event);
				target = this.util.findParent(target,"li");
				var index = this.__nsList.__getIndexFromTarget(target);
				var item = this.__nsList.__getItemByIndex(index);
				if(item)
				{
					retValue = this.__disableDropableFunction(item,this.__nsList.__labelField,item[this.__nsList.__fieldIndex],item[this.__nsList.__fieldDisableHover],target);
					retValue = !retValue;
				}
			}
	    	return retValue;
		};
		
		this.__initialize();
	};
	return NSList;
})();
nsModuleExport(this,"NSList",NSList);
